/// assets/custom-cart-drawer.js
if (true) {

  /**
   * 全局拦截 POST /cart/add（含 .js）：HTTP 成功即派发 cart:item_added，
   * 无需在 product-form、Bundle 等各处手动 dispatchEvent（仍保留 cart:open 供仅打开抽屉）。
   */
  (function installGlobalCartAddFetchInterceptor() {
    if (window.__YOUWEI_CART_ADD_FETCH_PATCH__) return;
    window.__YOUWEI_CART_ADD_FETCH_PATCH__ = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      let reqUrl = "";
      try {
        if (typeof input === "string") {
          reqUrl = input;
        } else if (input instanceof URL) {
          reqUrl = input.href;
        } else if (input instanceof Request) {
          reqUrl = input.url;
        } else if (input != null) {
          reqUrl = String(input);
        }
      } catch {
        reqUrl = "";
      }
      const method = (
        (input instanceof Request ? input.method : null) ||
        init?.method ||
        "GET"
      ).toUpperCase();
      let path = "";
      try {
        path = new URL(reqUrl, window.location.href).pathname.replace(/\/+$/, "");
      } catch {
        path = "";
      }
      const isCartAddPost =
        method === "POST" && /\/cart\/add(\.js)?$/i.test(path);
      let suppressCartEvent = false;
      try {
        const reqHeaders = new Headers(
          init?.headers || (input instanceof Request ? input.headers : undefined),
        );
        suppressCartEvent = reqHeaders.get("X-Youwei-Silent-Cart-Event") === "1";
      } catch {
        suppressCartEvent = false;
      }

      return nativeFetch(input, init).then((res) => {
        if (isCartAddPost && res.ok && !suppressCartEvent) {
          queueMicrotask(() => {
            document.dispatchEvent(new CustomEvent("cart:item_added"));
          });
        }
        // 503/429 自动重试：Shopify 边缘偶尔过载，静默重试 2 次（共 3 次请求）
        if (isCartAddPost && !suppressCartEvent && (res.status === 503 || res.status === 429)) {
          const retryCount = (init?.__youweiCartRetry || 0) + 1;
          if (retryCount <= 2) {
            console.warn(`[Cart] ${res.status} on /cart/add, retry ${retryCount}/2`);
            const delay = Math.min(400 * Math.pow(2, retryCount - 1), 1600);
            return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
              window.fetch(input, { ...(init || {}), __youweiCartRetry: retryCount })
            );
          }
        }
        return res;
      });
    };
  })();

  /**
   * 初始化自定义购物车抽屉逻辑
   */
  function initCustomCartDrawer() {
    const CART_DATA_CACHE_TTL_MS = 1500;

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const stableBundleGroupKey = (value) => {
      const input = String(value || "");
      let hash = 0;
      for (let i = 0; i < input.length; i++) {
        hash = (hash * 31 + input.charCodeAt(i)) >>> 0;
      }
      return `group_${hash.toString(36)}`;
    };
    const normalizeBundleProductsSignature = (products) => {
      const list = Array.isArray(products) ? products : [];
      return JSON.stringify(
        list
          .map((p) => ({
            id: p?.id ?? "",
            variant_id: p?.variant_id ?? "",
            sku: p?.sku ?? "",
            handle: p?.handle ?? "",
          }))
          .sort((a, b) => {
            const ak = `${a.sku}|${a.handle}|${a.variant_id}|${a.id}`;
            const bk = `${b.sku}|${b.handle}|${b.variant_id}|${b.id}`;
            return ak.localeCompare(bk);
          }),
      );
    };

    // ============================================================
    //  赠品规则配置
    //  从 DOM 元素 #shopify-custom-cart-drawer 的 data-gift-rules 读取
    //  格式: [{"threshold":5000,"variantIds":[123],"label":"满¥50赠赠品"}]
    //  如果 DOM 未配置则使用默认空数组（不启用赠品）
    // ============================================================
    function _loadGiftRules() {
      try {
        const el = document.getElementById("shopify-custom-cart-drawer");
        const raw = el?.dataset?.giftRules;
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed
          .filter(function (r) {
            return r && typeof r.threshold === "number" && r.threshold > 0
              && Array.isArray(r.variantIds) && r.variantIds.length > 0;
          })
          .map(function (r) {
            return {
              threshold: Math.max(1, Math.trunc(r.threshold)),
              variantIds: r.variantIds.map(function (id) { return Number(id); }).filter(Boolean),
              label: r.label || "",
            };
          });
      } catch (_) { return []; }
    }

    /**
     * 获取当前 PDP 主商品价格（单位：分）。
     * 优先从 product-form-component 的 data-product-price 读取，
     * 否则回退到 bundle-config-json 的 mainProduct.price。
     */
    async function _getMainProductPriceCents() {
      // 主商品价格（单位：分）。
      // 优先走 Storefront API 查真实 variant 价格（MoneyV2.amount 单位是「元」，×100 转分），最可靠；
      // 失败时回退到 product-form-component 的 data-product-price（Liquid variant.price，单位已是分）。
      try {
        const vid = document.querySelector('input[name="id"]')?.value;
        if (vid) {
          const map = await _fetchVariantsByIds([vid]);
          const v = map.get(Number(vid));
          if (v && v.price != null && v.price !== "") {
            const p = parseFloat(v.price);
            if (Number.isFinite(p)) return Math.round(p * 100);
          }
        }
      } catch (_) { /* 忽略 */ }
      try {
        const pfc = document.querySelector("product-form-component");
        if (pfc?.dataset?.productPrice != null && pfc.dataset.productPrice !== "") {
          const p = parseFloat(pfc.dataset.productPrice);
          if (Number.isFinite(p)) return Math.round(p);
        }
      } catch (_) { /* 忽略 */ }
      return 0;
    }

    /**
     * 根据金额（单位：分）计算应附加的赠品行（价格由后台置 0，前端不设置价格）。
     * @param {number} totalCents 当前应计入阈值判断的金额（分）
     * @param {number[]} [existingGiftVariantIds] 购物车中已存在的赠品 variant id（用于去重）
     * @returns {Array<{id:number, quantity:number, properties:object}>}
     */
    function _buildGiftLinesForAmount(totalCents, existingGiftVariantIds = []) {
      const rules = _loadGiftRules();
      if (!rules.length) return [];
      const lines = [];
      const seen = new Set((existingGiftVariantIds || []).map((id) => String(id)));
      rules.forEach(function (rule, ri) {
        if (totalCents >= rule.threshold) {
          rule.variantIds.forEach(function (vid) {
            // 修复：只跳过购物车中已存在的赠品，不再对本轮重复出现的相同 id 去重，
            // 保证两个相同的 id 也能各自加入，不会只添加一个产品。
            if (seen.has(String(vid))) return;
            lines.push({
              id: vid,
              quantity: 1,
              properties: {
                _is_gift: String(ri),
                "_gift_rule_label": rule.label || ("Rule " + (ri + 1)),
              },
            });
          });
        }
      });
      return lines;
    }

    /**
     * 触发购物车更新全局事件
     */
    const dispatchCartEvents = (itemCount) => {
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: { data: { itemCount, source: "custom-cart-drawer" } },
        }),
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", { bubbles: true }),
      );

    };

    Alpine.store("cart", {
      isOpen: false,
      isLoading: false,
      isUpdating: false,
      hasInitialized: false,
      _unsavedBundleCount: 0,
      data: null,
      errorMsg: "",
      _errorTimeout: null,
      _fetchCartPromise: null,
      _lastCartFetchedAt: 0,

      showError(msg) {
        this.errorMsg = msg;
        clearTimeout(this._errorTimeout);
        if (msg) {
          this._errorTimeout = setTimeout(() => {
            this.errorMsg = "";
          }, 2000);
        }
      },

      bundleSyncRevision: 0,

      init() {
        document.addEventListener("cart:open", () => this.openDrawer());
        document.addEventListener("cart:refresh", () => this.fetchCart(false, { force: true }));
        document.addEventListener("cart:item_added", () => {
          this.openDrawer({ refresh: false });
          // 彻底删除了 this.data = null; 保证新加的商品能正确继承旧商品的配置，从而立刻被合并抓取！
          setTimeout(() => {
            this.fetchCart(false, { force: true });
          }, 800);
        });
        // 页面加载时立即初始化购物车，不等抽屉打开
        this.fetchCart();
      },

      openDrawer(options = {}) {
        this.isOpen = true;
        document.body.style.overflow = "hidden";
        if (options.refresh !== false && !this.hasInitialized) {
          this.fetchCart();
        }
      },

      closeDrawer() {
        this.isOpen = false;
        document.body.style.overflow = "";
      },

      closeDrawerAndRedirect(url) {
        this.isOpen = false;
        document.body.style.overflow = "";
        window.location.href = url;
      },

      /**
       * 获取原始购物车与套餐配置数据
       */
      async _fetchRawData() {
        const cartData = await getcart();
        return {
          cartData,
          bundleHtml: null, // getcart 已经处理了 bundleData 合并，这里不需要再传 html
        };
      },

      /**
       * 将套餐配置附加到购物车子项
       */
      _attachBundleData(cartData, bundleHtml) {
        if (!bundleHtml) return cartData;
        try {
          let bundleData = null;

          // 优先尝试用正则匹配 <script type="application/json">
          const scriptMatch = bundleHtml.match(/<script\s+type="application\/json"[^>]*>([\s\S]*?)<\/script>/i);
          if (scriptMatch && scriptMatch[1]) {
            bundleData = JSON.parse(scriptMatch[1].trim());
          } else {
            // Fallback 用 DOMParser
            const doc = new DOMParser().parseFromString(bundleHtml, "text/html");
            bundleData = JSON.parse(doc.body.textContent.trim());
          }

          if (!bundleData || !bundleData.items) return cartData;

          cartData.items = cartData.items.map((item) => {
            const matchedBundleInfo = bundleData.items.find(
              (b) => b.key === item.key,
            );
            if (matchedBundleInfo) {
              const cap = matchedBundleInfo.compare_at_price;
              const price = matchedBundleInfo.price;
              if (cap && cap > price) {
                item.original_line_price = Math.max(
                  item.original_line_price || 0,
                  cap * item.quantity,
                );
              }
              if (matchedBundleInfo.bundle_config) {
                try {
                  item.bundle_config =
                    typeof matchedBundleInfo.bundle_config === "string"
                      ? JSON.parse(matchedBundleInfo.bundle_config)
                      : matchedBundleInfo.bundle_config;
                } catch (e) {
                  item.bundle_config = matchedBundleInfo.bundle_config;
                }
              }
              if (matchedBundleInfo.properties) {
                item.properties = {
                  ...(item.properties || {}),
                  ...matchedBundleInfo.properties,
                };
              }
            }
            return item;
          });
        } catch (e) { }
        return cartData;
      },

      _reuseKnownBundleData(cartData) {
        const knownItems = [
          ...(this.data?._rawItems || []),
          ...(this.data?.items || []),
        ];
        const byKey = new Map();
        const byVariant = new Map();

        knownItems.forEach((item) => {
          if (!item || !item.bundle_config) return;
          if (item.key) byKey.set(item.key, item);
          const variantKey = item.variant_id || item.id;
          if (variantKey && !byVariant.has(String(variantKey))) {
            byVariant.set(String(variantKey), item);
          }
        });

        cartData.items = (cartData.items || []).map((item) => {
          const known =
            byKey.get(item.key) ||
            byVariant.get(String(item.variant_id || item.id || ""));
          if (known?.bundle_config && !item.bundle_config) {
            item.bundle_config = known.bundle_config;
          }
          return item;
        });
        return cartData;
      },

      _applyCartData(cartData, bundleHtml = null, options = {}) {
        if (bundleHtml) {
          cartData = this._attachBundleData(cartData, bundleHtml);
        }
        
        cartData = this._reuseKnownBundleData(cartData);
        cartData._rawItems = [...(cartData.items || [])];

        let mainItems = [];
        let compItems = [];

        (cartData.items || []).forEach((item) => {
          if (item.properties && item.properties._is_component === "true") {
            compItems.push(item);
          } else {
            mainItems.push(item);
          }
        });

        mainItems = mainItems.filter((mainItem) => {
          let compTotalPrice = 0;
          let compTotalOrigPrice = 0;
          compItems.forEach((comp) => {
            // 核心修复：双重保险绑定，无视 Shopify Key 的重置漂移
            const matchById = comp.properties._bundle_id && mainItem.properties._bundle_id && comp.properties._bundle_id === mainItem.properties._bundle_id;
            const matchByKey = comp.properties._parent_key === mainItem.key;
            if (matchById || matchByKey) {
              compTotalPrice += comp.final_line_price || 0;
              compTotalOrigPrice += comp.original_line_price || comp.final_line_price || 0;
            }
          });
          mainItem.final_line_price += compTotalPrice;
          if (mainItem.original_line_price === undefined) {
            mainItem.original_line_price = mainItem.final_line_price - compTotalPrice;
          } else {
            mainItem.original_line_price += compTotalOrigPrice;
          }
          return mainItem.quantity > 0;
        });

        cartData.items = mainItems;
        cartData.uiGroups = this._buildUIGroups(cartData.items);
        cartData.item_count = mainItems.reduce(
          (acc, item) => acc + item.quantity,
          0,
        );

        this.bundleSyncRevision++;
        this.data = cartData;
        this._lastCartFetchedAt = Date.now();
        dispatchCartEvents(cartData.item_count);
        return cartData;
      },

      /**
       * 检查是否需要同步附加商品（全局按组精准对账）
       */
      _checkComponentSyncNeeded(items) {
        let expectedComps = new Map();
        let actualComps = new Map();

        items.forEach((item) => {
          if (!item.properties || item.properties._is_component !== "true") {
            if (item.properties && item.properties._components) {
              try {
                let compsStr = item.properties._components;
                if (typeof compsStr === "string") compsStr = compsStr.replace(/&quot;/g, '"');
                const comps = JSON.parse(compsStr);
                const mainQty = Math.max(1, item.quantity || 1);
                const groupId = item.properties._bundle_id || item.key;
                comps.forEach((comp) => {
                  if (comp.id && comp.quantity > 0) {
                    const key = String(comp.id) + "||" + groupId;
                    expectedComps.set(key, (expectedComps.get(key) || 0) + (comp.quantity * mainQty));
                  }
                });
              } catch (e) { }
            }
          } else {
            const vid = item.variant_id || item.id;
            const groupId = item.properties?._bundle_id || item.properties?._parent_key || "";
            if (vid) {
              const key = String(vid) + "||" + groupId;
              actualComps.set(key, (actualComps.get(key) || 0) + item.quantity);
            }
          }
        });

        for (let [key, expectedQty] of expectedComps.entries()) {
          if ((actualComps.get(key) || 0) !== expectedQty) return true;
        }
        for (let key of actualComps.keys()) {
          if (!expectedComps.has(key)) return true;
        }
        return false;
      },

      /**
       * 执行真正的同步（修复子商品丢失属性跑到主商品区的问题）
       */
      async _syncComponents(items) {
        let expectedCompsMap = new Map(); 
        let actualCompsMap = new Map();   
        let ghostKeys = [];

        items.forEach((item) => {
          if (!item.properties || item.properties._is_component !== "true") {
            if (item.properties && item.properties._components) {
              try {
                let compsStr = item.properties._components;
                if (typeof compsStr === "string") {
                  compsStr = compsStr.replace(/&quot;/g, '"');
                }
                const comps = JSON.parse(compsStr);
                const mainQty = Math.max(1, item.quantity || 1);
                comps.forEach((comp) => {
                  if (comp.id && comp.quantity > 0) {
                    const key = String(comp.id);
                    const addQty = comp.quantity * mainQty;
                    if (expectedCompsMap.has(key)) {
                      expectedCompsMap.get(key).quantity += addQty;
                    } else {
                      expectedCompsMap.set(key, {
                        id: comp.id,
                        quantity: addQty,
                        properties: {
                          _is_component: "true",
                          "_Part of Bundle": "Included Components",
                        },
                      });
                    }
                  }
                });
              } catch (e) { }
            }
          } else {
            const vid = item.variant_id || item.id;
            if (vid) {
              const key = String(vid);
              if (actualCompsMap.has(key)) {
                // 如果发现重复的组件行，将其标记为 ghost 予以删除，并把数量累加到保留行
                ghostKeys.push(item.key);
                actualCompsMap.get(key).quantity += item.quantity;
                actualCompsMap.get(key).hasDuplicates = true; 
              } else {
                // 🚀 核心修复 1：必须把现有的 properties 存下来，后续才能保护它不被抹除！
                actualCompsMap.set(key, { key: item.key, quantity: item.quantity, properties: item.properties });
              }
            } else {
              ghostKeys.push(item.key);
            }
          }
        });

        let removals = {};
        let directUpdates = []; // 改为数组记录详细更新信息
        let adds = [];

        ghostKeys.forEach((k) => {
          if (k) removals[k] = 0;
        });

        for (let [k, expected] of expectedCompsMap.entries()) {
          const actual = actualCompsMap.get(k);
          if (actual) {
            // 🚀 核心修复 2：将要修改的子商品放进数组，连同旧属性一并准备好
            if (actual.quantity !== expected.quantity || actual.hasDuplicates) {
              directUpdates.push({
                key: actual.key,
                quantity: expected.quantity,
                properties: actual.properties || expected.properties
              });
            }
          } else {
            adds.push(expected);
          }
        }

        for (let [k, actual] of actualCompsMap.entries()) {
          if (!expectedCompsMap.has(k)) {
            removals[actual.key] = 0;
          }
        }

        let errors = [];
        const PARALLEL_LIMIT = 1;
        const RETRY_WAIT_MS = 900;
        const RETRY_TIMES = 3;

        const isRateLimitedError = (err) => {
          const msg = String(err?.message || "").toLowerCase();
          return msg.includes("too many attempts") || msg.includes("too_many_requests") || msg.includes("429");
        };

        const withRetry = async (task) => {
          let lastErr;
          for (let attempt = 0; attempt <= RETRY_TIMES; attempt++) {
            try {
              return await task();
            } catch (err) {
              lastErr = err;
              if (attempt >= RETRY_TIMES || !isRateLimitedError(err)) {
                throw err;
              }
              await sleep(RETRY_WAIT_MS * (attempt + 1));
            }
          }
          throw lastErr;
        };

        const runInParallelBatches = async (tasks, limit = PARALLEL_LIMIT) => {
          for (let i = 0; i < tasks.length; i += limit) {
            const batch = tasks.slice(i, i + limit);
            const results = await Promise.allSettled(batch.map((fn) => fn()));
            results.forEach((res) => {
              if (res.status === "rejected") errors.push(res.reason);
            });
          }
        };

        if (Object.keys(removals).length > 0) {
          try {
            await updatecartlines(removals);
          } catch (e) {
            errors.push(e);
          }
        }

        // 🚀 核心修复 3：调用更新时，使用 updatecartline 并强制传入 properties！
        // 这样 Shopify 后端就不会抹除 _is_component 属性，子商品就永远隐身在子商品区。
        if (directUpdates.length > 0) {
          try {
            const changeTasks = directUpdates.map(
              (upd) => () => withRetry(() => updatecartline(upd.key, { quantity: upd.quantity, properties: upd.properties }))
            );
            await runInParallelBatches(changeTasks);
          } catch (e) {
            errors.push(e);
          }
        }

        if (adds.length > 0) {
          const mergedAdds = [];
          const mergeMap = new Map();
          adds.forEach((entry) => {
            const key = String(entry.id);
            if (mergeMap.has(key)) {
              mergeMap.get(key).quantity += entry.quantity;
            } else {
              const clone = { ...entry, properties: { ...entry.properties } };
              mergeMap.set(key, clone);
              mergedAdds.push(clone);
            }
          });

          try {
            await withRetry(() => addcartitems(mergedAdds));
          } catch (e) {
            const addTasks = mergedAdds.map((item) => () => withRetry(() => addcartitems([item])));
            await runInParallelBatches(addTasks);
          }
        }

        if (errors.length > 0) {
          throw errors[0]; 
        }
      },

      /**
       * 赠品同步：根据购物车总金额（不含赠品自身），对每条规则判断是否应添加/移除赠品行。
       * - 金额 >= threshold：赠品必须在购物车中（不存在则添加）
       * - 金额 <  threshold：赠品必须从购物车移除（存在则删除）
       * - 赠品行用 properties._is_gift = ruleIndex 标记归属规则
       * - 赠品行价格由 Shopify 后台设为 0，前端不做价格修改
       */
      async _syncGifts(cartData) {
        var rules = _loadGiftRules();
        if (!rules.length) return false;

        // 计算购物车总金额（排除已有赠品行，避免赠品自身金额影响阈值判断）
        var totalPriceExGift = 0;
        (cartData.items || []).forEach(function (item) {
          if (!(item.properties && item.properties._is_gift)) {
            totalPriceExGift += item.final_line_price || 0;
          }
        });

        var giftLines = (cartData.items || []).filter(function (item) {
          return item.properties && item.properties._is_gift;
        });

        // 按规则分组当前赠品行：ruleIndex -> [giftLine, ...]
        var currentGiftsByRule = {};
        giftLines.forEach(function (line) {
          var ri = line.properties._is_gift;
          if (!currentGiftsByRule[ri]) currentGiftsByRule[ri] = [];
          currentGiftsByRule[ri].push(line);
        });

        var didChange = false;

        for (var ri = 0; ri < rules.length; ri++) {
          var rule = rules[ri];
          var needed = totalPriceExGift >= rule.threshold;
          var currentLines = currentGiftsByRule[String(ri)] || [];

          if (needed) {
            // 需要赠品 — 检查每个 variantId 是否存在
            var existingVariantIds = {};
            currentLines.forEach(function (line) {
              existingVariantIds[String(line.variant_id || line.id)] = line;
            });

            var toAdd = [];
            rule.variantIds.forEach(function (vid) {
              if (!existingVariantIds[String(vid)]) {
                toAdd.push({
                  id: vid,
                  quantity: 1,
                  properties: {
                    _is_gift: String(ri),
                    "_gift_rule_label": rule.label || ("Rule " + (ri + 1)),
                  },
                });
              }
            });

            // 清理不属于当前规则的赠品行（variantId 不在规则中）
            var toRemoveKeys = [];
            currentLines.forEach(function (line) {
              var vid = line.variant_id || line.id;
              if (rule.variantIds.indexOf(Number(vid)) === -1) {
                toRemoveKeys.push(line.key);
              }
            });

            if (toAdd.length > 0) {
              try {
                await addcartitems(toAdd);
                didChange = true;
              } catch (e) {
                console.warn("[Gift] Failed to add gift items for rule " + ri, e);
              }
            }
            if (toRemoveKeys.length > 0) {
              try {
                var removals = {};
                toRemoveKeys.forEach(function (k) { removals[k] = 0; });
                await updatecartlines(removals);
                didChange = true;
              } catch (e) {
                console.warn("[Gift] Failed to remove stale gift items for rule " + ri, e);
              }
            }
          } else {
            // 不需要赠品 — 移除所有该规则的赠品行
            if (currentLines.length > 0) {
              try {
                var removals = {};
                currentLines.forEach(function (line) { removals[line.key] = 0; });
                await updatecartlines(removals);
                didChange = true;
              } catch (e) {
                console.warn("[Gift] Failed to remove gift items for rule " + ri, e);
              }
            }
          }
        }

        return didChange;
      },

      /**
       * 需求修改：彻底取消主商品的自动合并功能，让它们在购物车内独立显示。
       */
      async _mergeDuplicateBundles(items) {
        return false;
      },

      /**
       * 构建UI分组，将同一种套餐分到一组
       */
      _buildUIGroups(items) {
        let uiGroups = [];
        let uiGroupsMap = new Map();

        items.forEach((item) => {
          if (item.bundle_config) {
            let products =
              item.bundle_config.products?.products ||
              item.bundle_config.products ||
              item.bundle_config;

            let configStr = Array.isArray(products)
              ? normalizeBundleProductsSignature(products)
              : JSON.stringify(products);

            if (uiGroupsMap.has(configStr)) {
              uiGroupsMap.get(configStr).items.push(item);
            } else {
              let bg = {
                isBundleGroup: true,
                items: [item],
                configStr,
                key: stableBundleGroupKey(configStr),
              };
              uiGroupsMap.set(configStr, bg);
              uiGroups.push(bg);
            }
          } else {
            uiGroups.push({ isBundleGroup: false, items: [item], key: item.key });
          }
        });
        return uiGroups;
      },

      /**
       * 获取并处理购物车数据
       */
      async fetchCart(preserveError = false, options = {}) {
        const force = options.force === true;
        if (
          !force &&
          this.data &&
          this.hasInitialized &&
          Date.now() - this._lastCartFetchedAt < CART_DATA_CACHE_TTL_MS
        ) {
          return this.data;
        }
        if (this._fetchCartPromise) return this._fetchCartPromise;

        this._fetchCartPromise = this._fetchCartLean(preserveError).finally(() => {
          this._fetchCartPromise = null;
        });
        return this._fetchCartPromise;
        /*
  
        if (this._syncingCart) return;
        this._syncingCart = true;
        this.isLoading = true;
        if (!preserveError) this.showError("");
        try {
          let { cartData, bundleHtml } = await this._fetchRawData();
          cartData = this._attachBundleData(cartData, bundleHtml);
          cartData._rawItems = [...cartData.items];
  
          // 已经将同步组件的时机移动到了 handleCheckout
          // if (this._checkComponentSyncNeeded(cartData.items)) {
          //   await this._syncComponents(cartData.items);
          //   this._syncingCart = false;
          //   return this.fetchCart();
          // }
  
          let mainItems = [];
          let compItems = [];
  
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._is_component === "true") {
              compItems.push(item);
            } else {
              mainItems.push(item);
            }
          });
  
          // 彻底清查和过滤无父级、数量为0等无效数据，并合并价格
          mainItems = mainItems.filter(mainItem => {
            let compTotalPrice = 0;
            let compTotalOrigPrice = 0;
            compItems.forEach((comp) => {
              if (comp.properties._parent_key === mainItem.key) {
                compTotalPrice += comp.final_line_price || 0;
                compTotalOrigPrice += comp.original_line_price || comp.final_line_price || 0;
              }
            });
            mainItem.final_line_price += compTotalPrice;
            if (mainItem.original_line_price === undefined) {
              mainItem.original_line_price = mainItem.final_line_price - compTotalPrice;
            } else {
              mainItem.original_line_price += compTotalOrigPrice;
            }
  
            // 移除 UI 界面中数量其实为0的项目
            return mainItem.quantity > 0;
          });
  
          cartData.items = mainItems;
          cartData.uiGroups = this._buildUIGroups(cartData.items);
          cartData.item_count = mainItems.reduce(
            (acc, item) => acc + item.quantity,
            0,
          );
  
          // 先把可用数据渲染出来，避免后续 merge/sync 出错时抽屉变成空白
          this.bundleSyncRevision++;
          this.data = cartData;
          dispatchCartEvents(cartData.item_count);
  
          const merged = await this._mergeDuplicateBundles(cartData.items);
          if (merged) {
            this._syncingCart = false;
            return this.fetchCart();
          }
        } catch (error) {
          if (!preserveError) {
            const errorStr = String(error.message || "").toLowerCase();
            if (errorStr.includes("no valid id") || errorStr.includes("invalid") || errorStr.includes("expired")) {
              // 这类由于并发导致的 Key 失效技术错误静默处理，不展示给用户
            } else if (errorStr.includes("sold out") || errorStr.includes("inventory") || errorStr.includes("stock")) {
              this.showError(error.message);
            } else {
              this.showError("Failed to load cart. Please try again.");
            }
          }
          // 兜底：即使 bundle merge/change/update 失败（例如 422 售罄），也尽量展示基础 cart.js 数据
          try {
            const fallbackCart = await getcart();
            const fallbackMainItems = (fallbackCart.items || []).filter(
              (item) =>
                !(
                  item.properties &&
                  item.properties._is_component === "true"
                ) && item.quantity > 0,
            );
            fallbackCart.items = fallbackMainItems;
            fallbackCart.uiGroups = this._buildUIGroups(fallbackMainItems);
            fallbackCart.item_count = fallbackMainItems.reduce(
              (acc, item) => acc + item.quantity,
              0,
            );
            this.data = fallbackCart;
            dispatchCartEvents(fallbackCart.item_count);
          } catch (_) { }
        } finally {
          this.isLoading = false;
          this._syncingCart = false;
          this.hasInitialized = true;
  
          // 当一次完整的 fetchCart 流程真正结束时，主动清除 isUpdating 状态
          if (!this._isUpdatePending && !this.isSaving) {
            this.isUpdating = false;
          }
        }
        */
      },

      async _fetchCartLean(preserveError = false) {
        this._syncingCart = true;
        this.isLoading = true;
        if (!preserveError) this.showError("");
        try {
          const { cartData, bundleHtml } = await this._fetchRawData();
          // 在 _applyCartData 过滤子商品之前，用原始 items 做组件同步检查
          // 因为 _applyCartData 会把 _is_component === "true" 的行从 items 中移除
          const rawItems = [...(cartData.items || [])];
          this._applyCartData(cartData, bundleHtml);

          // 先合并重复 bundle 行，再同步组件。避免 _syncComponents 基于独立主商品创建子组件行后，
          // 合并删除了主商品行导致 _parent_key 失效。
          let merged = false;
          if (this.data?.items?.length) {
            merged = await this._mergeDuplicateBundles(this.data.items);
            if (merged) {
              const refreshedCart = await getcart();
              this._applyCartData(refreshedCart, null, { preserveBundleData: true });
              // 用合并后的 items 重新做 rawItems
              rawItems.splice(0, rawItems.length, ...(refreshedCart.items || []));
            }
          }

          // 在每次拉取购物车后检查主商品的 _components 属性，确保子商品行与主商品数量对齐
          // 修复：主商品成功加入但子商品未同步的问题
          if (this._checkComponentSyncNeeded(rawItems)) {
            await this._syncComponents(rawItems);
            // 同步完成后重新拉取最新数据刷新 UI
            const refreshedAfterSync = await getcart();
            this._applyCartData(refreshedAfterSync, null, { preserveBundleData: true });
          }

          // 合并后可能产生新的重复（sync 后再次合并一次确保干净）
          if (merged && this.data?.items?.length) {
            const merged = await this._mergeDuplicateBundles(this.data.items);
            if (merged) {
              const refreshedCart = await getcart();
              this._applyCartData(refreshedCart, null, { preserveBundleData: true });
            }
          }

          // 赠品同步：在所有 bundle 同步完成后执行，基于最终 cartData 金额判断
          // 如有变更（新增/删除赠品行）则重新拉取刷新 UI
          if (this.data?.items) {
            var giftChanged = await this._syncGifts(this.data);
            if (giftChanged) {
              var refreshedGift = await getcart();
              this._applyCartData(refreshedGift, null, { preserveBundleData: true });
            }
          }

        } catch (error) {
          if (!preserveError) {
            const errorStr = String(error.message || "").toLowerCase();
            if (errorStr.includes("no valid id") || errorStr.includes("invalid") || errorStr.includes("expired")) {
              // Keep key-expiry noise out of the UI.
            } else if (errorStr.includes("sold out") || errorStr.includes("inventory") || errorStr.includes("stock")) {
              this.showError(error.message);
            } else {
              this.showError("Failed to load cart. Please try again.");
            }
          }
          try {
            const cartData = await getcart();
            this._applyCartData(cartData, null, {
              preserveBundleData: true,
            });
          } catch (_) {
            // 兜底：确保 data 有值，否则 x-if 三个模板全不命中 → 空白页
            if (!this.data) {
              this.data = { items: [], item_count: 0, total_price: 0, currency: "CNY", uiGroups: [] };
              dispatchCartEvents(0);
            }
          }
        } finally {
          this.isLoading = false;
          this._syncingCart = false;
          this.hasInitialized = true;
          this.isUpdating = false;
        }
        return this.data;
      },

      _pendingQtyUpdates: {},
      _qtyUpdateTimeout: null,
      _qtyUpdateAbortController: null,
      _isUpdatePending: false, // 用于标记是否有主商品更新在等待处理

      updateItemQty(key, quantity) {
        if (!this.data) return;
        quantity = parseInt(quantity, 10);
        if (!Number.isFinite(quantity) || quantity < 0) quantity = 0;

        let item = this.data.items.find((i) => i.key === key);
        let diff = 0;
        if (item) {
          diff = quantity - item.quantity;
          if (diff === 0) return;

          let unitPrice =
            item.quantity > 0 ? item.final_line_price / item.quantity : 0;
          let origUnitPrice =
            item.quantity > 0 ? item.original_line_price / item.quantity : 0;

          const oldQty = quantity - diff;
          item.quantity = quantity;
          item.final_line_price = unitPrice * quantity;
          item.original_line_price = origUnitPrice * quantity;

          // 乐观更新 _bundle_max_qty 随 quantity 等比缩放
          if (
            item.properties &&
            item.properties._bundle_max_qty &&
            oldQty > 0 &&
            oldQty !== quantity
          ) {
            const totalMax =
              parseInt(item.properties._bundle_max_qty, 10) || 0;
            if (totalMax > 0) {
              item.properties._bundle_max_qty = String(
                Math.round((totalMax * quantity) / oldQty),
              );
            }
            
            // 核心修复：同步乐观更新签名，防止 Shopify 拉取的旧签名与数量不符引发错乱！
            if (item.properties._bundle_line_sig) {
               const variantKey = String(item.variant_id || item.id || String(item.key || "").split(":")[0]);
               item.properties._bundle_line_sig = `${variantKey}:${quantity}`;
            }
          }

          this.data.item_count += diff;
          this.data.total_price += (unitPrice * diff);
          dispatchCartEvents(this.data.item_count);

          if (quantity === 0) {
            this.data.items = this.data.items.filter((i) => i.key !== key);
            this.data.uiGroups = this._buildUIGroups(this.data.items);

            // IMPORTANT: Also clear out the components that belong to this item
            // so they get properly removed by `_checkComponentSyncNeeded`
            if (item.properties && item.properties._components) {
              item.properties._components = "[]";
            }
          }
          this.data = { ...this.data }; // ensure reactivity triggers
        }

        this._pendingQtyUpdates[key] = quantity;
        this._isUpdatePending = true;

        clearTimeout(this._qtyUpdateTimeout);
        this._qtyUpdateTimeout = setTimeout(async () => {
          if (this._qtyUpdateAbortController) {
            this._qtyUpdateAbortController.abort();
          }
          this._qtyUpdateAbortController = new AbortController();
          const signal = this._qtyUpdateAbortController.signal;

          this.isUpdating = true;
          this.showError("");
          const updates = { ...this._pendingQtyUpdates };
          this._pendingQtyUpdates = {};
          this._isUpdatePending = false;

          try {
            let updatedCart = null;
            let simpleUpdates = {};
            
            // 核心修复：更新 Bundle 主商品必须带上最新的签名属性，否则后端验证失败会退回！
            for (let [updKey, updQty] of Object.entries(updates)) {
              let targetItem = this.data?.items?.find(i => i.key === updKey);
              if (targetItem && targetItem.properties && targetItem.properties._bundle_line_sig) {
                updatedCart = await updatecartline(updKey, { quantity: updQty, properties: targetItem.properties }, { signal });
              } else {
                simpleUpdates[updKey] = updQty;
              }
            }
            
            if (Object.keys(simpleUpdates).length > 0) {
              updatedCart = await updatecartlines(simpleUpdates, { signal });
            }

            Alpine.store("cart").bundleSyncRevision++;

            if (updatedCart?.items) {
              await this.fetchCart(false, { force: true });
            }
          } catch (error) {
            if (error.name === 'AbortError') return;

            const errorStr = String(error.message || "").toLowerCase();
            const isInvalidId = errorStr.includes("no valid id") || errorStr.includes("invalid") || errorStr.includes("expired");

            if (isInvalidId) {
              console.warn("Qty update key expired, silently refetching...");
              this.data = null;
              await this.fetchCart(false, { force: true });
            } else {
              let msgToShow = "Failed to update item quantity.";
              if (errorStr.includes("sold out") || errorStr.includes("inventory") || errorStr.includes("stock")) {
                msgToShow = error.message;
              }
              this.showError(msgToShow);
              this.data = null;
              await this.fetchCart(true, { force: true });
            }
          } finally {
            if (!signal.aborted) {
              // fetchCart 在 _syncingCart 为 true 时会直接 return，原先条件可能导致 isUpdating 永远不恢复
              this.isUpdating = false;
            }
          }
        }, 800);
      },

      /**
       * 结算处理
       */
      async handleCheckout(event) {
        if (event) event.preventDefault();
        if (!this.canCheckout || this.isProcessing) return;

        this.isUpdating = true;
        this.showError("");

        try {
          // 在跳转结算前统一执行子商品同步
          const cartData = await getcart();
          if (this._checkComponentSyncNeeded(cartData.items)) {
            await this._syncComponents(cartData.items);
            // 同步后重新拉取最新数据，确保 this.data 反映最新状态
            const refreshed = await getcart();
            this._applyCartData(refreshed, null, { preserveBundleData: true });
          }

          // 二次校验：主商品数量与子商品总数必须匹配，不匹配则阻止跳转
          if (!this.canCheckout) {
            this.showError("Please complete your bundle selection before checkout.");
            this.isUpdating = false;
            return;
          }
        } catch (err) {
          console.error("Pre-checkout sync error:", err);
          this.showError("Error syncing cart before checkout. Please review your items and try again.");
          this.isUpdating = false;
          await this.fetchCart(true, { force: true });
          return;
        }

        // ---- Meta 追踪：InitiateCheckout（仅新增，不改动原有结算流程）----
        try {
          const mt = /** @type {any} */ (window.__metaTracking || {});
          const eventId = mt.newEventId ? mt.newEventId() : '';
          window.__youwei_lastInitiateCheckoutEventId = eventId; // 供后端 CAPI 复用同一 event_id
          const items = (this.data?.items || []).map((i) => ({
            id: String(i.variant_id || i.id || ''),
            quantity: i.quantity || 1,
          }));
          const ud = mt.getHashedUserData ? mt.getHashedUserData() : {};
          /** @type {Record<string, any>} */
          const content = {
            content_ids: items.map((i) => i.id).filter(Boolean),
            content_type: 'product',
            num_items: this.totalQty || 0,
            value: this.subtotalPrice ? this.subtotalPrice / 100 : 0,
            currency: this.data?.currency || (mt.getCurrency ? mt.getCurrency() : 'USD'),
            external_id: mt.getExternalId ? mt.getExternalId() : '',
          };
          if (ud.em) content.em = ud.em;
          if (ud.ph) content.ph = ud.ph;
          if (typeof fbq === 'function') {
            fbq('track', 'InitiateCheckout', content, { eventID: eventId });
          }
        } catch (e) { /* 追踪失败不影响结算 */ }

        window.location.href = window.Shopify.routes.root + "checkout";
      },

      formatMoney(cents) {
        if (!cents && cents !== 0) return "";
        const formatStr = document.getElementById("shopify-custom-cart-drawer")?.dataset.moneyFormat || "${{amount}}";
        const value = (cents / 100).toFixed(2);
        return formatStr
          .replace(/\{\{\s*amount\s*\}\}/, value)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parseInt(value, 10))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace(/\./, ","));
      },

      get totalQty() { return this.data?.item_count || 0; },
      get subtotalPrice() { return this.data?.total_price || 0; },
      // get freeShippingThreshold() { return 5000; },
      // get freeShippingProgress() { return Math.min(((this.data?.total_price || 0) / 5000) * 100, 100); },
      // get remainingForFreeShipping() { return Math.max(5000 - (this.data?.total_price || 0), 0); },
      _freeShippingThreshold: null,
      get freeShippingThresholdCents() {
        if (this._freeShippingThreshold == null) {
          const el = document.getElementById("shopify-custom-cart-drawer");
          const raw = el?.dataset?.freeShippingThreshold;
          const num = parseFloat(raw);
          this._freeShippingThreshold = !isNaN(num) && num > 0 ? Math.round(num * 100) : 0;
        }
        return this._freeShippingThreshold;
      },
      get freeShippingThreshold() { return this.freeShippingThresholdCents; },
      get freeShippingProgress() {
        const t = this.freeShippingThresholdCents;
        if (!t || !this.data?.total_price) return 100;
        return Math.min((this.data.total_price / t) * 100, 100);
      },
      get remainingForFreeShipping() {
        const t = this.freeShippingThresholdCents;
        if (!t) return 0;
        return Math.max(t - (this.data?.total_price || 0), 0);
      },
      get isProcessing() {
        return this.isUpdating || this._isUpdatePending || this._unsavedBundleCount > 0;
      },
      get canCheckout() {
        if (!this.data || !this.data.uiGroups) return true;
        for (const group of this.data.uiGroups) {
          if (group.isBundleGroup) {
            let maxItems = 0;
            let currentTotal = 0;
            group.items.forEach((item) => {
              const cfg = item.bundle_config || {};
              let max1 = parseInt(cfg.max_length || cfg.max_items || 0, 10) || 0;
              let max2 = parseInt(cfg.min_length || cfg.min_items || 0, 10) || 0;
              let maxPerUnit = Math.max(max1, max2);

              const propsMax = parseInt(item.properties?._bundle_max_qty || "0", 10) || 0;

              if (maxPerUnit === 0) {
                if (propsMax > 0 && item.quantity > 0) {
                  maxPerUnit = Math.round(propsMax / item.quantity);
                } else {
                  let prods = cfg.products?.products || cfg.products || cfg;
                  if (Array.isArray(prods)) {
                    maxPerUnit = prods.length;
                  }
                }
              }

              maxItems += maxPerUnit * item.quantity;

              // 计算这个 item 内部的子商品数量（properties 存 per-unit，乘以 item.quantity）
              let itemTotal = 0;
              if (item.properties) {
                Object.keys(item.properties).forEach(k => {
                  // 放行 _qty_ 前缀（隐藏属性），兼容旧数据
                  if (k.startsWith("_qty_") || (!k.startsWith("_") && k !== "Part of Bundle")) {
                    let qty = parseInt(item.properties[k], 10);
                    if (!isNaN(qty)) itemTotal += qty;
                  }
                });
              }
              currentTotal += itemTotal * item.quantity;
            });

            if (maxItems > 0 && currentTotal !== maxItems) return false;
          }
        }
        return true;
      },
    });

    Alpine.data("customCartDrawer", () => ({
      get isOpen() { return Alpine.store("cart").isOpen; },
      set isOpen(val) { Alpine.store("cart").isOpen = val; },
      get isLoading() { return Alpine.store("cart").isLoading; },
      get isUpdating() { return Alpine.store("cart").isUpdating; },
      get isProcessing() { return Alpine.store("cart").isProcessing; },
      get hasInitialized() { return Alpine.store("cart").hasInitialized; },
      get data() { return Alpine.store("cart").data; },
      get errorMsg() { return Alpine.store("cart").errorMsg; },

      openDrawer() { Alpine.store("cart").openDrawer(); },
      closeDrawer() { Alpine.store("cart").closeDrawer(); },
      closeDrawerAndRedirect(url) { Alpine.store("cart").closeDrawerAndRedirect(url); },
      fetchCart() { return Alpine.store("cart").fetchCart(); },
      updateItemQty(key, quantity) { return Alpine.store("cart").updateItemQty(key, quantity); },
      handleCheckout(event) { return Alpine.store("cart").handleCheckout(event); },
      formatMoney(cents) { return Alpine.store("cart").formatMoney(cents); },

      get totalQty() { return Alpine.store("cart").totalQty; },
      get subtotalPrice() { return Alpine.store("cart").subtotalPrice; },
      get freeShippingThreshold() { return Alpine.store("cart").freeShippingThreshold; },
      get freeShippingProgress() { return Alpine.store("cart").freeShippingProgress; },
      get remainingForFreeShipping() { return Alpine.store("cart").remainingForFreeShipping; },
      get canCheckout() { return Alpine.store("cart").canCheckout; },
      hasConfiguredBundle(key) { return false; }
    }));

    const bundleProductsCache =
      window.__YOUWEI_BUNDLE_PRODUCTS_CACHE__ ||
      (window.__YOUWEI_BUNDLE_PRODUCTS_CACHE__ = new Map());
    const bundleConfiguratorStateCache =
      window.__YOUWEI_BUNDLE_CONFIGURATOR_STATE_CACHE__ ||
      (window.__YOUWEI_BUNDLE_CONFIGURATOR_STATE_CACHE__ = new Map());

    document.addEventListener("click", (e) => {
      const target = e.target.closest('button[name="checkout"], input[name="checkout"]');
      if (target && !target.closest("#custom-cart-drawer-form") && window.Alpine && Alpine.store("cart")) {
        e.preventDefault();
        if (!Alpine.store("cart").canCheckout || Alpine.store("cart").isProcessing) {
          Alpine.store("cart").openDrawer();
        } else if (Alpine.store("cart").handleCheckout) {
          Alpine.store("cart").handleCheckout(e);
        }
      }
    });

    // ============================================================
    //  共享 Bundle PDP Store — 子商品数据 + Buy Now 逻辑
    //  bundleSubProducts / bundleBuyNow 两个组件共享同一 Store
    // ============================================================
    Alpine.store("productBundle", {
      products: [],
      quantities: {},
      isLoading: false,
      hasBundle: false,
      bundleConfig: null,
      isBuying: false,
      colorPickerOpen: false,
      colorPickerSelectedKey: null,
      colorTitle: "",
      _inited: false,

      get currentTotal() {
        return this.products.reduce((sum, p) => sum + (Number(this.quantities[p._key]) || 0), 0);
      },

      get maxItems() {
        const cfg = this.bundleConfig || {};
        return Math.max(
          parseInt(cfg.max_length || cfg.max_items || 0, 10) || 0,
          parseInt(cfg.min_length || cfg.min_items || 0, 10) || 0
        ) || (Array.isArray(cfg.products?.products || cfg.products) ? cfg.products.products.length || cfg.products.length : 0) || this.products.length;
      },

      get isBundleReady() {
        if (this.maxItems <= 0) return true;
        return this.currentTotal === this.maxItems;
      },

      variantHasSellableStock(p) {
        if (!p || !(p.id || p.variant_id)) return false;
        if (p.available === false) return false;
        if (p.inventory_management === "shopify" && p.inventory_policy === "deny") {
          return (typeof p.inventory_quantity === "number" ? p.inventory_quantity : 0) > 0;
        }
        return true;
      },

      loadBundleConfig(variantId, jsonStr) {
        if (!jsonStr) { this.hasBundle = false; return; }
        let parsed;
        try { parsed = JSON.parse(jsonStr); } catch { this.hasBundle = false; return; }
        const cfg = parsed?.config;
        if (!cfg) { this.hasBundle = false; return; }

        const raw = cfg.products?.products || cfg.products || [];
        if (!Array.isArray(raw) || !raw.length) {
          this.hasBundle = false; this.bundleConfig = null; return;
        }

        this.bundleConfig = cfg;
        this.hasBundle = true;

        // ★ 检查缓存是否已预热（预热完成后命中率 ~100%）
        const allVariantIds = raw.map(p => p.variant_id || p.id).filter(Boolean);
        const cache = window.__YOUWEI_VARIANT_CACHE__;
        const allCached = cache && allVariantIds.length > 0 && allVariantIds.every((id) => cache.has(id));

        // 构建产品列表：缓存命中时内联 enrichment，一次性赋值，避免 Alpine 2 轮更新
        const cachedEntries = allCached
          ? new Map(allVariantIds.map((id) => [id, cache.get(id)]))
          : null;

        const prods = raw.map((p, i) => {
          const v = cachedEntries ? cachedEntries.get(p.variant_id || p.id) : null;
          let apiColor = "";
          if (v) {
            const vt = (v.variant_title || v.sku || v.title || "");
            if (vt) apiColor = String(vt).split("-").pop()?.trim()?.toLowerCase() || "";
          }
          return {
            _key: p.variant_id || p.sku || `_${i}`,
            id: p.variant_id || p.id,
            variant_id: p.variant_id || (Number.isFinite(p.id) ? p.id : null),
            sku: (v ? v.sku : "") || p.sku || "",
            title: (v ? v.title : "") || p.title || "",
            variant_title: (v ? v.variant_title : "") || p.variant_title || "",
            color: p.color || apiColor,
            image: p.image || (v ? v.image : "") || "",
            price: p.price != null ? p.price : (v ? v.price : null),
            available: v ? v.available : (p.available !== false),
            inventory_quantity: v ? v.inventory_quantity : (p.inventory_quantity != null ? p.inventory_quantity : 999),
            inventory_policy: (v ? v.inventory_policy : "") || p.inventory_policy || "deny",
            inventory_management: (v ? v.inventory_management : "") || p.inventory_management || null,
            default_quantity: Math.max(0, parseInt(p.default_quantity || 0, 10) || 0),
          };
        });

        // ★ 一次性赋值：enriched products + quantities + cached 全局数据
        const enriched = allCached ? prods : null;
        if (enriched) window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__ = enriched;
        this.products = enriched
          ? enriched.filter(p => this.variantHasSellableStock(p))
          : prods;

        const qtys = {};
        if (prods.some(p => p.default_quantity > 0)) {
          prods.forEach(p => { qtys[p._key] = p.default_quantity; });
        } else if (this.maxItems > 0 && prods.length > 0) {
          const base = Math.floor(this.maxItems / prods.length);
          let rem = this.maxItems - base * prods.length;
          prods.forEach(p => { qtys[p._key] = base + (rem-- > 0 ? 1 : 0); });
        } else {
          prods.forEach(p => { qtys[p._key] = 0; });
        }
        this.quantities = qtys;

        // 缓存未命中时降级走异步 GraphQL
        if (allVariantIds.length > 0 && !allCached) {
          const self = this;
          (async () => {
            try {
              const real = await _fetchVariantsByIds(allVariantIds);
              if (real.size > 0) {
                self._applyEnrichment(prods, real);
              }
            } catch (_) {}
          })();
        }
      },

      /**
       * 从 __YOUWEI_VARIANT_CACHE__ 同步完成 enrichment，
       * 无需网络请求，变体切换时立即生效。
       */
      _enrichProductsFromCache(prods, allVariantIds) {
        const cache = window.__YOUWEI_VARIANT_CACHE__;
        if (!cache) return;
        const real = new Map();
        allVariantIds.forEach((id) => {
          const v = cache.get(id);
          if (v) real.set(id, v);
        });
        if (real.size > 0) {
          this._applyEnrichment(prods, real);
        }
      },

      /**
       * 将 enrichment 数据应用到 products 并更新 store（公共逻辑）
       */
      _applyEnrichment(prods, real) {
        const enriched = prods.map(p => {
          const v = real.get(p.variant_id);
          let apiColor = "";
          const vt = (v?.variant_title || v?.sku || v?.title || "");
          if (vt) apiColor = String(vt).split("-").pop()?.trim()?.toLowerCase() || "";
          return {
            ...p,
            variant_id: p.variant_id || (v?.variant_id || v?.id),
            title: p.title || v?.title || "",
            variant_title: p.variant_title || v?.variant_title || "",
            sku: p.sku || v?.sku || "",
            available: v ? v.available : p.available,
            inventory_quantity: v ? v.inventory_quantity : p.inventory_quantity,
            inventory_management: v ? v.inventory_management : p.inventory_management,
            inventory_policy: v ? v.inventory_policy : p.inventory_policy,
            image: (!p.image && v?.image) ? v.image : p.image,
            color: p.color || apiColor,
          };
        });
        window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__ = enriched;
        this.products = enriched.filter(p => this.variantHasSellableStock(p));
        this.products = [...this.products];
      },

      init() {
        if (this._inited) return;
        this._inited = true;
        // ★ 页面加载时预热：扫描所有变体的 bundle-config-json，一次性请求所有子商品数据到缓存
        this._warmupAllVariantCaches();
        this.refreshBundleConfig();
        const handler = () => setTimeout(() => this.refreshBundleConfig(), 0);
        document.addEventListener("variant:update", handler);
        this._handler = handler;
        this._onVariantSelectedBound = () => { this.isLoading = true; };
        document.addEventListener("variant:selected", this._onVariantSelectedBound);
        let last = "";
        this._poll = setInterval(() => {
          const idInput = document.querySelector('input[name="id"]');
          if (idInput?.value && idInput.value !== last) {
            last = idInput.value;
            this.refreshBundleConfig();
          }
        }, 300);
      },

      /**
       * 页面加载时扫描所有 script.bundle-config-json，
       * 收集所有变体的子商品 variant_id，一次性预热 __YOUWEI_VARIANT_CACHE__。
       * 这样后续变体切换时 enrichment 全程同步，无网络延迟。
       */
      _warmupAllVariantCaches() {
        const allIds = new Set();
        const scripts = document.querySelectorAll("script.bundle-config-json");
        scripts.forEach((script) => {
          if (!script.textContent) return;
          try {
            const data = JSON.parse(script.textContent);
            const cfg = data?.config;
            const raw = cfg?.products?.products || cfg?.products || [];
            if (Array.isArray(raw)) {
              raw.forEach((p) => {
                const vid = p.variant_id || p.id;
                if (vid) allIds.add(vid);
              });
            }
          } catch (_) {}
        });
        const idList = [...allIds];
        if (idList.length > 0) {
          // 静默预热，不阻塞页面渲染
          _fetchVariantsByIds(idList).catch(() => {});
        }
      },

      _destroy() {
        this._inited = false;
        clearInterval(this._poll);
        if (this._handler) document.removeEventListener("variant:update", this._handler);
        if (this._onVariantSelectedBound) document.removeEventListener("variant:selected", this._onVariantSelectedBound);
      },

      defaultQuantity(p) {
        return p?.default_quantity != null ? Number(p.default_quantity) : 0;
      },

      _getSelectedBundleConfigScript() {
        const radio = document.querySelector("input.bundle-radio-trigger:checked");
        const radioId = radio?.dataset?.variantId;
        const idVal = document.querySelector('input[name="id"]')?.value;

        for (const script of document.querySelectorAll("script.bundle-config-json")) {
          if (!script.textContent) continue;
          try {
            const d = JSON.parse(script.textContent);
            if (radioId && String(d.variantId) === String(radioId)) return script;
            if (idVal && String(d.variantId) === String(idVal)) return script;
          } catch (_) {}
        }
        return null;
      },

      refreshBundleConfig() {
        const script = this._getSelectedBundleConfigScript();
        if (!script?.textContent) {
          this.hasBundle = false; this.bundleConfig = null;
          this.products = []; this.quantities = {};
          this.isLoading = false;
          // 清除旧 enriched 缓存
          window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__ = null;
          return;
        }
        try {
          const data = JSON.parse(script.textContent);
          const vid = String(data?.variantId ?? "");
          if (this._loadedVId === vid && this.hasBundle && this.products.length) {
            this.isLoading = false;
            return;
          }
          this._loadedVId = vid;
          this.bundleConfig = null;
          this.products = []; this.quantities = {};
          this.loadBundleConfig(vid, script.textContent);
          this.isLoading = false;
        } catch (_) {
          this.hasBundle = false; this.bundleConfig = null;
          this.products = []; this.quantities = {};
          this.isLoading = false;
        }
      },

      async buyNow(event) {
        if (event?.preventDefault) event.preventDefault();
        if (this.isBuying || (this.hasBundle && !this.isBundleReady)) return;

        const mainVariantId = document.querySelector('input[name="id"]')?.value;
        if (!mainVariantId) return;
        const qtyInput = this.form?.querySelector('input[name="quantity"]');
        const quantity = Math.max(1, Math.trunc(Number(qtyInput?.value) || 1));
        const lines = [];
        const bundleId = this.hasBundle ? generateyouweibundleid() : null;
        const entries = [];

        this.products.forEach(p => {
          const q = Number(this.quantities[p._key]) || 0;
          if (q <= 0 || !(p.variant_id || p.id)) return;
          entries.push({
            id: p.variant_id || p.id,
            quantity: q,
            label: (p.variant_title && p.variant_title !== "Default Title")
              ? p.variant_title
              : (p.title || p.sku || String(p._key)),
          });
        });

        if (this.hasBundle && bundleId && entries.length) {
          // 合并相同 variant_id 的子商品，不要分开创建多行
          const mergedEntries = [];
          const byId = new Map();
          entries.forEach(e => {
            const key = String(e.id);
            if (byId.has(key)) {
              byId.get(key).quantity += e.quantity;
            } else {
              const merged = { ...e };
              byId.set(key, merged);
              mergedEntries.push(merged);
            }
          });
          // 更新 label 为合并后的数量
          mergedEntries.forEach(e => {
            e.label = (this.products.find(p => String(p.variant_id || p.id) === String(e.id))?.variant_title)
              || e.label;
          });

          const mainProps = {
            ...makeprops_bundle_main(
              bundleId,
              Object.fromEntries(mergedEntries.map(e => ["_qty_" + e.label, String(e.quantity)])),
              mergedEntries.map(e => ({ id: e.id, quantity: e.quantity }))
            ),
            ...makeprops_drawer_bundle_totals({
              bundleTotalQty: mergedEntries.reduce((s, e) => s + e.quantity, 0),
              bundleMaxQty: this.maxItems,
            }),
          };

          // 先放 bundle 子商品
          mergedEntries.forEach(e => {
            lines.push({
              merchandiseId: `gid://shopify/ProductVariant/${e.id}`,
              quantity: e.quantity,
              attributes: _cartLineAttributesFromProps(
                makeprops_bundle_component(mainVariantId, {
                  bundleId,
                  parentBundleId: bundleId,
                })
              ),
            });
          });

          // 最后再放主商品，这样如果 checkout 按“最后加入的在最上面”显示，
          // 主商品就会排在最上面
          lines.push({
            merchandiseId: `gid://shopify/ProductVariant/${mainVariantId}`,
            quantity,
            ...(Object.keys(mainProps).length ? {
              attributes: _cartLineAttributesFromProps(mainProps)
            } : {}),
          });
        } else {
          lines.push({
            merchandiseId: `gid://shopify/ProductVariant/${mainVariantId}`,
            quantity,
          });
        }

        // ---- 赠品逻辑：直接 Buy Now 时也按满额规则附加赠品 ----
        // Buy Now 通过 cartCreate 创建全新购物车直跳结算，只含本次购买商品，
        // 因此阈值判断仅基于本次购买金额（主商品 + bundle 子商品）。
        try {
          const giftRules = _loadGiftRules();
          if (giftRules.length) {
            const mainPriceCents = await _getMainProductPriceCents();
            const thisAddCents = mainPriceCents * quantity;

            const giftLines = _buildGiftLinesForAmount(thisAddCents);
            giftLines.forEach((g) => {
              lines.push({
                merchandiseId: `gid://shopify/ProductVariant/${g.id}`,
                quantity: g.quantity,
                attributes: _cartLineAttributesFromProps(g.properties),
              });
            });
          }
        } catch (_) { /* 赠品逻辑失败不阻塞 Buy Now */ }

        this.isBuying = true;
        await new Promise((r) => setTimeout(r, 80));
        try {
          const url = await youweiBuyNow(lines);
          if (url) {
            // ---- Meta 追踪：InitiateCheckout（Buy Now 直跳结算，与 AddToCart 同源参数格式）----
            try {
              const mt = /** @type {any} */ (window.__metaTracking || {});
              const eventId = mt.newEventId ? mt.newEventId() : '';
              window.__youwei_lastInitiateCheckoutEventId = eventId; // 供后端 CAPI 复用同一 event_id
              const contentIds = lines.map((l) => String(l.merchandiseId || '').split('/').pop()).filter(Boolean);
              const numItems = lines.reduce((s, l) => s + (Number(l.quantity) || 0), 0);
              const pfc = document.querySelector('product-form-component');
              const mainPrice = parseFloat(pfc?.dataset?.productPrice || '0') || 0;
              const contentName = pfc?.dataset?.productTitle || '';
              let value = mainPrice * quantity;
              this.products.forEach((p) => {
                const q = Number(this.quantities[p._key]) || 0;
                value += (parseFloat(p.price) || 0) * q;
              });
              const ud = mt.getHashedUserData ? mt.getHashedUserData() : {};
              /** @type {Record<string, any>} */
              const content = {
                content_ids: contentIds,
                content_type: 'product',
                content_name: contentName,
                num_items: numItems,
                value: Math.round(value * 100) / 100,
                currency: mt.getCurrency ? mt.getCurrency() : 'USD',
                external_id: mt.getExternalId ? mt.getExternalId() : '',
              };
              if (ud.em) content.em = ud.em;
              if (ud.ph) content.ph = ud.ph;
              if (typeof fbq === 'function') {
                fbq('track', 'InitiateCheckout', content, { eventID: eventId });
              }
            } catch (e) { /* 追踪失败不影响跳转 */ }

            window.location.href = url;
          }
        } catch (err) {
          console.error("Buy now failed:", err);
          if (window?.alert) window.alert("Unable to start checkout. Please try again.");
        } finally { this.isBuying = false; }
      }
    });

    // 颜色网格组件：内联颜色切换（点击圆点 / 箭头切换）
    Alpine.data("productBundleConfigurator", () => ({
      variantName: "",
      shippingBadge: "",
      // 弹窗状态
      colorPickerIndex: -1,   // 当前正在切换颜色的 slot 索引（-1 表示未打开）
      // ★ 持久化每个 slot 对应的 product._key（不随 quantities 重排而变）
      slotKeys: [],
      init() {
        const store = Alpine.store("productBundle");
        store.init();
        this._refreshBadges();
        this._rebuildSlots();
        // ★ 用 $watch 监听 products 引用变化（enrichment 完成后重新赋值时触发），
        // 避免事件时序问题导致读到旧数据
        this.$watch(() => store.products, () => {
          this._rebuildSlots();
        });
        document.addEventListener("variant:update", () => {
          this._refreshBadges();
        });
        document.addEventListener("bundle:quantities-changed", () => {
          this._rebuildSlots();
        });
      },
      _refreshBadges() {
        const radio = document.querySelector("input.bundle-radio-trigger:checked");
        if (!radio || radio === this._lastBadgeRadio) return;
        this._lastBadgeRadio = radio;
        const wrapper = radio.closest(".variant-card__wrapper");
        const span = wrapper?.querySelector(".variant-card__variant-name");
        this.variantName = span?.textContent?.trim() || "";
        const badge = wrapper?.querySelector(".badge--shipping");
        this.shippingBadge = badge?.textContent?.trim() || "";
      },
      get products() { return Alpine.store("productBundle").products; },
      get quantities() { return Alpine.store("productBundle").quantities; },
      get hasBundle() { return Alpine.store("productBundle").hasBundle; },
      get isLoading() { return Alpine.store("productBundle").isLoading; },
      get currentTotal() { return Alpine.store("productBundle").currentTotal; },
      get maxItems() { return Alpine.store("productBundle").maxItems; },
      get colorPickerOpen() { return this.colorPickerIndex >= 0; },
      variantHasSellableStock(p) { return Alpine.store("productBundle").variantHasSellableStock(p); },
      defaultQuantity(p) { return Alpine.store("productBundle").defaultQuantity(p); },

      /** 所有可售卖产品 */
      get allSellableProducts() {
        const enriched = window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__;
        if (enriched && enriched.length) return enriched.filter(p => p.available === true);
        return this.products.filter(p => this.variantHasSellableStock(p));
      },

      /** 所有 enriched 产品（含无库存的） */
      get allEnrichedProducts() {
        return window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__ || this.products;
      },

      /** 根据 quantities 重建 slotKeys（仅在 init / variant切换时调用） */
      _rebuildSlots() {
        const keys = [];
        const store = Alpine.store("productBundle");
        store.products.forEach(p => {
          const q = store.quantities[p._key] || 0;
          for (let i = 0; i < q; i++) keys.push(p._key);
        });
        this.slotKeys = keys;
      },

      /** 展开 slot 列表（基于持久化的 slotKeys） */
      get flattenedSlots() {
        const enriched = window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__;
        return this.slotKeys.map((key, si) => {
          const found = enriched ? enriched.find(p => p._key === key) : null;
          const p = found || this.products.find(p => p._key === key) || {};
          return { ...p, _slotIndex: si };
        });
      },

      /** 工具：获取颜色 class */
      getProductColorClass(prod) {
        if (prod?.color) return prod.color;
        const vt = (prod.variant_title && prod.variant_title !== 'Default Title' ? prod.variant_title : (prod.title || prod.sku || ''));
        return vt.split('-').pop().trim().toLowerCase();
      },

      // ===== 下拉选择器相关 =====
      openColorPickerForSlot(slotIndex) {
        this.colorPickerIndex = slotIndex;
      },
      /** 兼容旧的 sticker bar 调用：打开 bundle-color-picker dialog */
      openColorPicker() {
        Alpine.store("productBundle").colorPickerOpen = true;
        window.dispatchEvent(new CustomEvent("bundle-color-picker:open"));
      },
      closeColorPicker() {
        this.colorPickerIndex = -1;
      },
      /** 下拉中所有可选颜色（去重：每个 variant_id 只显示一次） */
      get colorPickerOptions() {
        const all = this.allEnrichedProducts;
        const seen = new Map();
        const deduped = [];
        all.forEach(p => {
          const key = p.variant_id || p.id || p.sku || p._key;
          if (!seen.has(key)) {
            seen.set(key, true);
            deduped.push(p);
          }
        });
        return deduped;
      },
      /** 下拉当前 slot 对应的产品 */
      get colorPickerCurrentProduct() {
        if (this.colorPickerIndex < 0 || this.colorPickerIndex >= this.slotKeys.length) return null;
        const key = this.slotKeys[this.colorPickerIndex];
        const enriched = window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__;
        return (enriched ? enriched.find(p => p._key === key) : null)
          || this.products.find(p => p._key === key) || null;
      },
      /** 下拉当前颜色在 allEnrichedProducts 中的索引 */
      get colorPickerCurrentIndex() {
        const cur = this.colorPickerCurrentProduct;
        if (!cur) return 0;
        const curVid = cur.variant_id || cur.id;
        return this.allEnrichedProducts.findIndex(p => (p.variant_id || p.id) === curVid);
      },
      /** 下拉中选择某个颜色（sold-out 不可选，用 variant_id 匹配） */
      selectColorInPicker(newProduct, keepOpen = false) {
        if (this.colorPickerIndex < 0) return;
        if (newProduct.available === false) return;
        const curProd = this.colorPickerCurrentProduct;
        // 用 variant_id 匹配，因为 _key 含索引后缀在去重后不相等
        if (curProd && String(curProd.variant_id || curProd.id) === String(newProduct.variant_id || newProduct.id)) return;

        // ★ 只改当前 slot，不动其他 slot
        const newSlotKeys = [...this.slotKeys];
        newSlotKeys[this.colorPickerIndex] = newProduct._key;
        this.slotKeys = newSlotKeys;

        // 同步 quantities（从 slotKeys 重新计算）
        const store = Alpine.store("productBundle");
        const newQtys = {};
        newSlotKeys.forEach(k => {
          newQtys[k] = (newQtys[k] || 0) + 1;
        });
        store.quantities = newQtys;

        if (!keepOpen) this.closeColorPicker();
      },
      /** 下拉箭头：上一个颜色（跳过 sold-out，不关闭下拉） */
      pickerPrev() {
        const opts = this.allEnrichedProducts;
        if (!opts.length) return;
        const curKey = this.slotKeys[this.colorPickerIndex];
        const curIdx = opts.findIndex(p => p._key === curKey);
        const total = opts.length;
        let idx = curIdx < 0 ? 0 : curIdx;
        for (let i = 0; i < total; i++) {
          idx = (idx - 1 + total) % total;
          if (opts[idx].available !== false) {
            this.selectColorInPicker(opts[idx], true);
            return;
          }
        }
      },
      /** 下拉箭头：下一个颜色（跳过 sold-out，不关闭下拉） */
      pickerNext() {
        const opts = this.allEnrichedProducts;
        if (!opts.length) return;
        const curKey = this.slotKeys[this.colorPickerIndex];
        const curIdx = opts.findIndex(p => p._key === curKey);
        const total = opts.length;
        let idx = curIdx < 0 ? 0 : curIdx;
        for (let i = 0; i < total; i++) {
          idx = (idx + 1) % total;
          if (opts[idx].available !== false) {
            this.selectColorInPicker(opts[idx], true);
            return;
          }
        }
      },
    }));

    // 购买按钮组件：仅负责渲染 Buy Now 按钮（对应 snippets/product-bundle-buy-now.liquid）
    Alpine.data("bundleBuyNow", () => ({
      init() { Alpine.store("productBundle").init(); },
      get hasBundle() { return Alpine.store("productBundle").hasBundle; },
      get isLoading() { return Alpine.store("productBundle").isLoading; },
      get isBuying() { return Alpine.store("productBundle").isBuying; },
      get isBundleReady() { return Alpine.store("productBundle").isBundleReady; },
      buyNow(event) { return Alpine.store("productBundle").buyNow(event); },
    }));

    /**
     * 从 SKU 提取颜色单词（SKU 最后一个 - 后的部分）
     */
    function _extractColorFromSku(sku) {
      if (!sku) return "";
      const parts = String(sku).split("-");
      return parts[parts.length - 1]?.trim()?.toLowerCase() || "";
    }

    /**
     * 获取商品颜色：优先 color 字段，没有则取 SKU 最后一个 - 后的颜色单词
     */
    function _getProductColor(p) {
      if (p?.color) return p.color;
      const skuColor = _extractColorFromSku(p?.sku);
      if (skuColor) return skuColor;
      // 最后 fallback：variant_title 中 - 后的部分
      const vt = p?.variant_title || "";
      if (vt && vt !== "Default Title") {
        const parts = vt.split("-");
        const last = parts[parts.length - 1]?.trim()?.toLowerCase();
        if (last) return last;
      }
      return "";
    }

    // 颜色选择弹窗组件（对应 snippets/bundle-color-picker.liquid，使用 <dialog>）
     Alpine.data("bundleColorPicker", () => ({
      /** 每个 slot 当前选中的 product._key */
      slotColors: [],
      /** 初始化过没 */
      _built: false,
      _onOpen: null,
      /** 内联下拉：当前打开的是哪个 slot（-1 = 关闭） */
      colorPickerIndex: -1,

      init() {
        Alpine.store("productBundle").init();
        this._onOpen = () => { this._buildSlots(); this.open(); };
        window.addEventListener("bundle-color-picker:open", this._onOpen);
      },
      get products() { return Alpine.store("productBundle").products; },
      get quantities() { return Alpine.store("productBundle").quantities; },
      get maxItems() { return Alpine.store("productBundle").maxItems; },

      /** "Pick Your Color" 可选的子商品（过滤 __YOUWEI_PRODUCT_BUNDLE_ENRICHED__ 中 available === true） */
      get sellableProducts() {
        const enriched = window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__;
        if (enriched && enriched.length) {
          return enriched.filter(p => p.available === true);
        }
        return this.products.filter((p) =>
          Alpine.store("productBundle").variantHasSellableStock(p),
        );
      },

      /** 所有 enriched 产品（含无库存的，供下拉展示） */
      get allEnrichedProducts() {
        return window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__ || this.products;
      },

      /** 根据 key 找到 product（优先从 enriched 找，保留完整字段） */
      _findProduct(key) {
        const enriched = window.__YOUWEI_PRODUCT_BUNDLE_ENRICHED__;
        if (enriched && enriched.length) {
          return enriched.find((p) => p._key === key || p.variant_id === key) || null;
        }
        return this.products.find((p) => p._key === key || p.variant_id === key) || null;
      },

      getColor(p) {
        return _getProductColor(p);
      },

      /** 工具：获取颜色 class（与 productBundleConfigurator 一致） */
      getProductColorClass(prod) {
        if (prod?.color) return prod.color;
        const vt = (prod.variant_title && prod.variant_title !== 'Default Title' ? prod.variant_title : (prod.title || prod.sku || ''));
        return vt.split('-').pop().trim().toLowerCase();
      },

      _buildSlots() {
        const slots = [];
        for (const p of this.sellableProducts) {
          const q = this.quantities[p._key] || 0;
          for (let i = 0; i < q; i++) {
            slots.push(p._key);
          }
        }
        const remain = this.maxItems - slots.length;
        if (remain > 0) {
          const first = this.sellableProducts[0];
          if (first) {
            const store = Alpine.store("productBundle");
            store.quantities = {
              ...store.quantities,
              [first._key]: (store.quantities[first._key] || 0) + remain,
            };
            for (let i = 0; i < remain; i++) {
              slots.push(first._key);
            }
          }
        }
        this.slotColors = slots.slice(0, this.maxItems);
        this._built = true;
      },

      /** 获取 slot[i] 对应的 product */
      getSlotProduct(i) {
        const key = this.slotColors[i];
        return this._findProduct(key);
      },

      /** slot[i] 的图片 */
      getSlotImage(i) {
        const p = this.getSlotProduct(i);
        return p?.image || "";
      },

      // ===== 内联下拉选择器（与 pdp-color-list 交互一致） =====
      openColorPickerForSlot(slotIndex) {
        this.colorPickerIndex = slotIndex;
      },
      closeColorPicker() {
        this.colorPickerIndex = -1;
      },
      /** 点击内容区：如果点击的不是 .pdp-color-item__dropdown 内的元素，关闭下拉 */
      onContentClick(event) {
        if (this.colorPickerIndex < 0) return;
        const target = event.target;
        const dropdown = this.$el.querySelector('.pdp-color-item__dropdown:not([style*="display: none"])');
        if (dropdown && !dropdown.contains(target)) {
          this.closeColorPicker();
        }
      },

      /** 下拉中所有可选颜色（去重：每个 variant_id 只显示一次） */
      get colorPickerOptions() {
        const all = this.allEnrichedProducts;
        const seen = new Map();
        const deduped = [];
        all.forEach(p => {
          const key = p.variant_id || p.id || p.sku || p._key;
          if (!seen.has(key)) {
            seen.set(key, true);
            deduped.push(p);
          }
        });
        return deduped;
      },
      /** 下拉当前 slot 对应的产品 */
      get colorPickerCurrentProduct() {
        if (this.colorPickerIndex < 0 || this.colorPickerIndex >= this.slotColors.length) return null;
        const key = this.slotColors[this.colorPickerIndex];
        return this._findProduct(key);
      },
      /** 下拉中选择某个颜色（sold-out 不可选） */
      selectColorInPicker(newProduct, keepOpen = false) {
        if (this.colorPickerIndex < 0) return;
        if (newProduct.available === false) return;
        const curProd = this.colorPickerCurrentProduct;
        if (curProd && String(curProd.variant_id || curProd.id) === String(newProduct.variant_id || newProduct.id)) return;

        const oldKey = this.slotColors[this.colorPickerIndex];
        this.slotColors.splice(this.colorPickerIndex, 1, newProduct._key);

        const store = Alpine.store("productBundle");
        store.quantities = {
          ...store.quantities,
          [oldKey]: Math.max(0, (store.quantities[oldKey] || 0) - 1),
          [newProduct._key]: (store.quantities[newProduct._key] || 0) + 1,
        };
        document.dispatchEvent(new CustomEvent("bundle:quantities-changed"));

        if (!keepOpen) this.closeColorPicker();
      },
      /** 下拉箭头：上一个颜色（跳过 sold-out，不关闭下拉） */
      pickerPrev() {
        const opts = this.allEnrichedProducts;
        if (!opts.length) return;
        const curKey = this.slotColors[this.colorPickerIndex];
        const curIdx = opts.findIndex(p => p._key === curKey);
        const total = opts.length;
        let idx = curIdx < 0 ? 0 : curIdx;
        for (let i = 0; i < total; i++) {
          idx = (idx - 1 + total) % total;
          if (opts[idx].available !== false) {
            this.selectColorInPicker(opts[idx], true);
            return;
          }
        }
      },
      /** 下拉箭头：下一个颜色（跳过 sold-out，不关闭下拉） */
      pickerNext() {
        const opts = this.allEnrichedProducts;
        if (!opts.length) return;
        const curKey = this.slotColors[this.colorPickerIndex];
        const curIdx = opts.findIndex(p => p._key === curKey);
        const total = opts.length;
        let idx = curIdx < 0 ? 0 : curIdx;
        for (let i = 0; i < total; i++) {
          idx = (idx + 1) % total;
          if (opts[idx].available !== false) {
            this.selectColorInPicker(opts[idx], true);
            return;
          }
        }
      },

      /** <dialog>.showModal() */
      open() {
        this._buildSlots();
        this.closeColorPicker();
        const dialog = this.$el.querySelector("dialog");
        if (dialog && !dialog.open) dialog.showModal();
      },

      /** <dialog>.close() */
      close() {
        this.closeColorPicker();
        const dialog = this.$el.querySelector("dialog");
        if (dialog) dialog.close();
      },
    }));

    // ============================================================
    //  Sticky Product Bar Store（滚动吸顶栏）
    //  当页面向下滚动到一定距离时出现
    // ============================================================
    Alpine.store("stickyProductBar", {
      visible: false,
      enabled: true,
      title: "",
      price: 0,
      compareAtPrice: null,
      image: "",
      selectedVariantId: "",
      variants: [],
      _scrollThreshold: 400,
      _inited: false,

      init() {
        if (this._inited) return;
        this._inited = true;

        // 从页面抓取初始数据
        this._capturePageData();

        // 监听变体切换
        document.addEventListener("variant:update", (e) => {
          const resource = e?.detail?.resource;
          if (!resource) return;
          this.selectedVariantId = String(resource.id || "");
          this.price = resource.price || 0;
          this.compareAtPrice = resource.compare_at_price || null;
          // 图片：优先从事件 resource 取，其次从 DOM 卡片取
          const eventImg = resource.featured_media?.preview_image?.src;
          if (eventImg) {
            this.image = eventImg;
          } else {
            const radio = document.querySelector(
              `variant-picker input[type='radio'][data-variant-id='${resource.id}']`
            );
            if (radio) {
              const label = radio.closest("label");
              const bundleScript = label?.querySelector(".bundle-config-json");
              if (bundleScript?.textContent) {
                try {
                  const bundleData = JSON.parse(bundleScript.textContent);
                  if (bundleData?.mainProduct?.image) {
                    this.image = bundleData.mainProduct.image;
                  }
                } catch (_) {}
              }
              if (!this.image) {
                const cardImg = label?.parentElement?.querySelector(".variant-card__image-wrapper img");
                if (cardImg?.src) this.image = cardImg.src;
              }
            }
          }
          // 同步更新 variants 列表中的价格
          if (this.variants.length) {
            const idx = this.variants.findIndex(
              (v) => String(v.id) === String(resource.id)
            );
            if (idx >= 0) {
              this.variants[idx].price = resource.price || 0;
              this.variants[idx].compare_at_price = resource.compare_at_price || null;
            }
          }
        });

        document.addEventListener("variant:selected", (e) => {
          // variant:selected 传的是 option_value_id（非 variant_id），
          // 不要用它更新 selectedVariantId，variant:update 会传正确值
        });

        // 监听滚动：product-information 元素底部滚出屏幕顶部时出现
        let ticking = false;
        const checkVisibility = () => {
          // 每次实时读取 DOM 属性，避免 refresh 后缓存旧值
          const root = document.querySelector("#sticky-product-bar-root");
          const enabled = root?.dataset?.stickyBarEnabled !== "false";
          if (!enabled) { this.visible = false; return; }
          const el = document.querySelector(".product-information");
          if (el) {
            this.visible = el.getBoundingClientRect().bottom < 0;
          } else {
            this.visible = window.scrollY > this._scrollThreshold;
          }
        };
        window.addEventListener("scroll", () => {
          if (!ticking) {
            requestAnimationFrame(() => { checkVisibility(); ticking = false; });
            ticking = true;
          }
        }, { passive: true });
      },

      /** 从页面 DOM 抓取产品标题、图片、变体列表 */
      _capturePageData() {
        // 标题
        const titleEl = document.querySelector(".product-details .view-product-title a")
          || document.querySelector("h1[class*='product']")
          || document.querySelector(".product-details h1");
        if (titleEl) this.title = titleEl.textContent.trim();

        // 初始选中变体 ID
        const idInput = document.querySelector('input[name="id"]');
        if (idInput?.value) this.selectedVariantId = idInput.value;

        // 变体列表：从 variant-picker 的 radio inputs 中收集
        this._collectVariants();

        // 初始价格：从 product-price 组件获取
        const priceContainer = document.querySelector("product-price");
        if (priceContainer) {
          const salePrice = priceContainer.querySelector(".price__sale .price-item--regular:not(.price-item--last)")
            || priceContainer.querySelector(".price-item--sale");
          const comparePrice = priceContainer.querySelector(".price__sale .price-item--last")
            || priceContainer.querySelector(".price-item--regular");
          if (comparePrice && !priceContainer.querySelector(".price__sale")) {
            // 无折扣时只有 regular
            this.compareAtPrice = null;
          }
        }

        // 图片：优先从当前选中变体的 bundle-config-json 取 mainProduct.image
        const currentRadio = document.querySelector(
          "variant-picker input[type='radio'][data-variant-id]:checked"
        );
        if (currentRadio) {
          const label = currentRadio.closest("label");
          const bundleScript = label?.querySelector(".bundle-config-json");
          if (bundleScript?.textContent) {
            try {
              const bundleData = JSON.parse(bundleScript.textContent);
              if (bundleData?.mainProduct?.image) {
                this.image = bundleData.mainProduct.image;
              }
            } catch (_) {}
          }
          // fallback: 卡片内的 img
          if (!this.image) {
            const cardImg = label?.parentElement?.querySelector(".variant-card__image-wrapper img");
            if (cardImg?.src) this.image = cardImg.src;
          }
        }
        // 最后兜底：产品详情页媒体区图片
        if (!this.image) {
          const img = document.querySelector(".product-information__media img")
            || document.querySelector("[data-testid='product-information-media'] img");
          if (img?.src) this.image = img.src;
        }
      },

      /** 从 variant-picker 的 radio 收集变体列表 */
      _collectVariants() {
        const radios = document.querySelectorAll(
          "variant-picker input[type='radio'][data-variant-id]"
        );
        if (!radios.length) return;

        const seen = new Set();
        const list = [];
        radios.forEach((radio) => {
          const vid = radio.dataset.variantId;
          if (!vid || seen.has(vid)) return;
          seen.add(vid);

          const label = radio.closest("label");
          // 从卡片中提取标题：variant-card__variant-name
          const nameEl = label?.parentElement?.querySelector(".variant-card__variant-name")
            || label?.querySelector(".variant-option__button-label");
          const name = nameEl?.textContent?.trim() || "";

          // 从卡片中提取价格：variant-card__price
          const priceEl = label?.parentElement?.querySelector(".variant-card__price");
          const compareEl = label?.parentElement?.querySelector(".variant-card__compare-price");

          // 从 bundle-config-json 提取主商品价格
          let price = null;
          let compareAt = null;
          const bundleScript = label?.querySelector(".bundle-config-json");
          if (bundleScript?.textContent) {
            try {
              const bundleData = JSON.parse(bundleScript.textContent);
              if (bundleData?.mainProduct?.price != null) {
                price = bundleData.mainProduct.price;
              }
            } catch (_) {}
          }

          // fallback: 从渲染的 price/compare 文本解析
          if (price == null && priceEl?.textContent) {
            const parsed = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ""));
            if (!isNaN(parsed)) price = Math.round(parsed * 100);
          }
          if (compareAt == null && compareEl?.textContent) {
            const parsed = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ""));
            if (!isNaN(parsed)) compareAt = Math.round(parsed * 100);
          }

          list.push({
            id: vid,
            name: name,
            price: price,
            compare_at_price: compareAt,
            available: radio.dataset.optionAvailable !== "false",
          });
        });
        this.variants = list;

        // 从选中的 radio 确定当前变体（而非依赖 input[name="id"]，类型可能不一致）
        const selectedRadio = document.querySelector(
          "variant-picker input[type='radio'][data-variant-id]:checked"
        );
        const activeId = selectedRadio?.dataset?.variantId || this.selectedVariantId;
        if (activeId) this.selectedVariantId = String(activeId);

        // 设置当前选中价格
        const current = list.find((v) => String(v.id) === String(activeId));
        if (current) {
          this.price = current.price || 0;
          this.compareAtPrice = current.compare_at_price || null;
        }
      },

      /** 下拉切换变体 → 触发页面变体切换 */
      selectVariant(variantId) {
        if (String(variantId) === String(this.selectedVariantId)) return;
        const radio = document.querySelector(
          `variant-picker input[type='radio'][data-variant-id='${variantId}']`
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      },

      get formattedPrice() {
        return Alpine.store("cart").formatMoney(this.price);
      },

      get formattedCompareAtPrice() {
        if (!this.compareAtPrice || this.compareAtPrice <= this.price) return "";
        return Alpine.store("cart").formatMoney(this.compareAtPrice);
      },

      /** 当前选中变体的显示名 */
      get selectedVariantName() {
        const v = this.variants.find((x) => String(x.id) === this.selectedVariantId);
        return v?.name || "";
      },

      /** Buy Now 操作 */
      buyNow(event) {
        const pdpBundle = Alpine.store("productBundle");
        if (pdpBundle) {
          pdpBundle.buyNow(event);
        }
      },
    });


    Alpine.data("bundleConfiguratorComponent", (initialGroup) => ({
      groupConfigStr: initialGroup.configStr,
      fallbackGroup: initialGroup,
      products: [],
      quantities: {},
      isLoading: true,
      isSaving: false,
      _saveTimeout: null,
      _pendingSave: false,
      _needsRefreshPending: false,
      _isSavePendingFlag: false,

      get storeItems() {
        const d = Alpine.store("cart").data;
        if (d && d.uiGroups) {
          const g = d.uiGroups.find((x) => x.configStr === this.groupConfigStr);
          if (g && g.items && g.items.length) return g.items;
        }
        return this.fallbackGroup && this.fallbackGroup.items
          ? this.fallbackGroup.items
          : [];
      },

      get storeItemsSig() {
        return this.storeItems
          .map(
            (i) => `${i.variant_id || i.id || i.key.split(":")[0]}:${i.quantity}`,
          )
          .sort()
          .join("|");
      },

      _getProductsCacheKey(rawProds) {
        if (this.groupConfigStr) return `group:${this.groupConfigStr}`;
        return `raw:${normalizeBundleProductsSignature(rawProds)}`;
      },

      _cloneResolvedProducts(products) {
        return (products || []).map((p) => ({ ...p }));
      },

      _getConfiguratorStateCacheKey(rawProds) {
        return `configurator:${this.groupConfigStr || normalizeBundleProductsSignature(rawProds)}`;
      },

      _buildLineSigFromItems(items) {
        return (items || [])
          .map((item) => {
            const variantKey =
              item?.variant_id ||
              item?.id ||
              String(item?.key || "").split(":")[0];
            return `${variantKey}:${item?.quantity || 0}`;
          })
          .sort()
          .join("|");
      },

      get maxItems() {
        return this.storeItems.reduce((sum, item) => {
          const cfg = item.bundle_config || {};
          const max1 = parseInt(cfg.max_length || cfg.max_items || 0, 10) || 0;
          const max2 = parseInt(cfg.min_length || cfg.min_items || 0, 10) || 0;
          let maxPerUnit = Math.max(max1, max2);
          const propsMax = parseInt(item.properties?._bundle_max_qty || "0", 10) || 0;
          if (maxPerUnit === 0) {
            if (propsMax > 0 && item.quantity > 0) {
              maxPerUnit = Math.round(propsMax / item.quantity);
            } else {
              const prods = cfg.products?.products || cfg.products || cfg;
              if (Array.isArray(prods)) maxPerUnit = prods.length;
            }
          }
          return sum + maxPerUnit * item.quantity;
        }, 0);
      },

      get currentTotal() {
        return this.products.reduce((sum, p) => sum + (Number(this.quantities[p._key]) || 0), 0);
      },

      /** 无库存 / 不可售的配色不展示（与 canIncrease 库存规则一致） */
      variantHasSellableStock(p) {
        if (!p || !(p.id || p.variant_id)) return false;
        if (p.available === false) return false;
        if (p.inventory_management === "shopify" && p.inventory_policy === "deny") {
          const q = typeof p.inventory_quantity === "number" ? p.inventory_quantity : 0;
          return q > 0;
        }
        return true;
      },

      canIncrease(p) {
        if (this.maxItems > 0 && this.currentTotal >= this.maxItems) return false;
        const currentQty = this.quantities[p._key] || 0;
        let stockLimit = Infinity;
        if (p.inventory_management === "shopify" && p.inventory_policy === "deny") {
          stockLimit = typeof p.inventory_quantity === "number" ? p.inventory_quantity : 0;
        }
        return currentQty + 1 <= stockLimit;
      },

      async init() {
        try {
          const firstItem = this.storeItems[0];
          if (!firstItem) return;
          const rawProds =
            firstItem.bundle_config?.products?.products ||
            firstItem.bundle_config?.products ||
            [];
          const stateCacheKey = this._getConfiguratorStateCacheKey(rawProds);
          if (bundleConfiguratorStateCache.has(stateCacheKey)) {
            this.products = this._cloneResolvedProducts(
              bundleConfiguratorStateCache.get(stateCacheKey),
            );
            return;
          }
          const cacheKey = this._getProductsCacheKey(rawProds);
          if (!bundleProductsCache.has(cacheKey)) {
            bundleProductsCache.set(cacheKey, this.resolveProducts(rawProds));
          }
          this.products = this._cloneResolvedProducts(
            await bundleProductsCache.get(cacheKey),
          );
          bundleConfiguratorStateCache.set(
            stateCacheKey,
            this._cloneResolvedProducts(this.products),
          );
        } catch (err) {
        } finally {
          this.isLoading = false;
          this.syncQuantities();
        }
        this.$watch(() => this.storeItemsSig, (newSig, oldSig) => {
          if (newSig && newSig !== oldSig) this.syncQuantities();
        });
      },

      hasDefault(p) {
        return this.storeItems.some((item) => {
          const prods =
            item.bundle_config?.products?.products ||
            item.bundle_config?.products ||
            [];
          const match = this._getBundleConfigMatch(prods, p);
          return match && parseInt(match.default_quantity || 0, 10) > 0;
        });
      },

      _normalizeBundlePropToken(value) {
        return String(value || "")
          .trim()
          .toUpperCase()
          .replace(/[^A-Z0-9]+/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-|-$/g, "");
      },

      _expandBundlePropAliases(value) {
        const raw = String(value || "").trim();
        if (!raw) return [];
        const aliases = new Set();
        const full = this._normalizeBundlePropToken(raw);
        if (full) aliases.add(full);

        const parts = raw
          .split(/[^A-Za-z0-9]+/)
          .map((part) => this._normalizeBundlePropToken(part))
          .filter(Boolean);

        for (let i = 0; i < parts.length; i++) {
          aliases.add(parts[i]);
          const suffix = parts.slice(i).join("-");
          if (suffix) aliases.add(suffix);
        }

        return [...aliases];
      },

      _getProductPropertyAliases(p) {
        const aliases = new Set();
        [
          p?._propertyLabel,
          p?.title,
          p?.variant_title,
          p?.sku,
          p?.handle,
          p?.variant_id,
          p?.id,
        ].forEach((value) => {
          this._expandBundlePropAliases(value).forEach((alias) => aliases.add(alias));
        });
        return aliases;
      },

      _findMatchingPropertyKey(itemProps, p) {
        if (!itemProps || !p) return null;
        const productAliases = this._getProductPropertyAliases(p);
        if (!productAliases.size) return null;

        for (const key of Object.keys(itemProps)) {
          // 允许 _qty_ 前缀通过，其余 _ 开头的内部属性跳过
          if (!key || (key.startsWith("_") && !key.startsWith("_qty_"))) continue;
          // 去除 _qty_ 前缀后再做名称匹配
          const actualKey = key.startsWith("_qty_") ? key.replace("_qty_", "") : key;
          const keyAliases = this._expandBundlePropAliases(actualKey);
          if (keyAliases.some((alias) => productAliases.has(alias))) {
            return key;
          }
        }
        return null;
      },

      _getMatchedPropertyQty(itemProps, p) {
        const key = this._findMatchingPropertyKey(itemProps, p);
        if (!key) return { key: null, qty: 0 };
        const raw = String(itemProps[key] ?? "").trim();
        const n = parseInt(raw, 10);
        const qty = Number.isFinite(n) ? Math.max(0, Math.trunc(n)) : 0;
        return { key, qty };
      },

      /**
       * 写入 cart/line properties 时用的「展示用」键名：优先 variant / 商品标题，不要沿用行里旧的 SKU 当 key，
       * 否则标题下会一直显示 PICPAK-00-XXX 这种技术字段。
       * 读数量仍走 _findMatchingPropertyKey（可匹配历史 SKU key）。
       */
      _getPreferredPropertyKey(p) {
        const vt = String(p?.variant_title || "").trim();
        const goodVariantTitle = vt && vt !== "Default Title";
        return (
          (goodVariantTitle ? vt : "") ||
          String(p?._propertyLabel || "").trim() ||
          String(p?.title || "").trim() ||
          String(p?.sku || "").trim() ||
          String(p?.variant_id || p?.id || p?._key || "")
        );
      },

      _getBundleConfigMatch(bundleProducts, p) {
        const list = Array.isArray(bundleProducts) ? bundleProducts : [];
        const productAliases = this._getProductPropertyAliases(p);

        return list.find((ip) => {
          if (!ip) return false;
          if (p?.sku && ip.sku && ip.sku === p.sku) return true;
          if (p?.id != null && (ip.id === p.id || ip.variant_id === p.id)) return true;
          if (
            p?.variant_id != null &&
            (ip.id === p.variant_id || ip.variant_id === p.variant_id)
          ) {
            return true;
          }

          const itemAliases = this._expandBundlePropAliases(
            ip.title || ip.variant_title || ip.sku || ip.handle || ip.variant_id || ip.id,
          );
          return itemAliases.some((alias) => productAliases.has(alias));
        }) || null;
      },

      _getReferencePerUnitQuantities() {
        for (const item of this.storeItems) {
          const lineQty = Math.max(1, Number(item?.quantity) || 0);
          const perUnit = {};
          let totalPerUnit = 0;

          this.products.forEach((p) => {
            const matched = this._getMatchedPropertyQty(item?.properties || {}, p);
            if (matched.qty > 0) {
              const perUnitQty = matched.qty / lineQty;
              perUnit[p._key] = perUnitQty;
              totalPerUnit += perUnitQty;
            }
          });

          if (totalPerUnit > 0) {
            return { perUnit, totalPerUnit };
          }
        }
        return null;
      },

      /**
       * 解析并补全商品数组数据
       */
      async resolveProducts(rawProds) {
        if (!Array.isArray(rawProds) || !rawProds.length) return [];

        const products = rawProds.map((p, i) => ({
          _key: p.variant_id || p.sku || `_${i}`,
          id: p.variant_id || p.id,
          variant_id: p.variant_id || (Number.isFinite(p.id) ? p.id : null),
          sku: p.sku || "",
          title: p.title || "",
          variant_title: p.variant_title || "",
          image: p.image || "",
          price: p.price != null ? p.price : null,
          handle: p.handle || "",
          available: p.available !== false,
          inventory_quantity: p.inventory_quantity != null ? p.inventory_quantity : null,
          inventory_policy: p.inventory_policy || "deny",
          inventory_management: p.inventory_management || null,
        }));

        // 收集需要补充数据的 variant_id（缺失 title/image/inventory 的）
        const needEnrich = products
          .filter((p) => !p.title || !p.image || p.inventory_quantity == null)
          .map((p) => p.variant_id)
          .filter(Boolean);

        if (needEnrich.length > 0) {
          const enriched = await _fetchVariantsByIds(needEnrich);
          if (enriched.size > 0) {
            for (const p of products) {
              const e = enriched.get(p.variant_id);
              if (!e) continue;
              if (!p.title) p.title = e.title || p.sku;
              if (!p.image) p.image = e.image;
              if (p.price == null) p.price = e.price;
              if (!p.handle) p.handle = e.handle;
              if (p.inventory_quantity == null) p.inventory_quantity = e.inventory_quantity;
              if (!p.variant_title) p.variant_title = e.variant_title;
              p.available = e.available;
              p.inventory_policy = e.inventory_policy;
            }
          }
        }

        // title 兜底 & _propertyLabel & hasDefault
        for (const p of products) {
          if (!p.title) p.title = p.sku || "Product";
          if (p.inventory_quantity == null) p.inventory_quantity = 999;
          if (p.inventory_policy === undefined || p.inventory_policy == null) p.inventory_policy = "deny";

          const vt = String(p.variant_title || "").trim();
          p._propertyLabel =
            (vt && vt !== "Default Title" ? vt : "") ||
            String(p.title || "").trim() ||
            String(p.sku || "").trim() ||
            String(p.variant_id || p.id || p._key || "");
          p.hasDefault = this.hasDefault(p);
        }

        return products;
      },

      /**
       * 计算签名不变情况下的商品数量
       */
      _syncUnchangedQuantities(newQtys) {
        this.storeItems.forEach((item) => {
          const itemQty = Math.max(1, Number(item?.quantity) || 0);
          let itemProps = item.properties || {};
          this.products.forEach((p) => {
            const matched = this._getMatchedPropertyQty(itemProps, p);
            if (matched.qty > 0) {
              // matched.qty 是 per-unit 值，乘以 itemQty 得到总量
              newQtys[p._key] += matched.qty * itemQty;
            }
          });
        });
      },

      /**
       * 计算缩放或初始化变更时的商品数量
       */
      _syncChangedQuantities(newQtys, exactQtys) {
        const referenceQuantities = this._getReferencePerUnitQuantities();

        this.storeItems.forEach((item) => {
          const itemQty = Math.max(1, Number(item.quantity) || 0);
          const cfg = item.bundle_config || {};
          let currentCapacity = Math.max(
            parseInt(cfg.max_length || cfg.max_items || 0),
            parseInt(cfg.min_length || cfg.min_items || 0),
          );
          const propsMax = parseInt(item.properties?._bundle_max_qty || "0", 10) || 0;
          if (currentCapacity === 0) {
            if (propsMax > 0 && item.quantity > 0) {
              currentCapacity = Math.round(propsMax / item.quantity);
            } else {
              const prods = cfg.products?.products || cfg.products || cfg;
              if (Array.isArray(prods)) {
                currentCapacity =
                  prods.reduce(
                    (sum, ip) => sum + (parseInt(ip?.default_quantity || 0, 10) || 0),
                    0,
                  ) || prods.length;
              }
            }
          }
          const lineCapacity =
            currentCapacity > 0
              ? currentCapacity * itemQty
              : 0;

          let oldCapacity =
            parseInt(item.properties?._bundle_max_qty || "0", 10) / item.quantity;
          if (isNaN(oldCapacity)) oldCapacity = 0;
          let hasOurConfig = !!item.properties?._bundle_line_sig;

          if (hasOurConfig) {
            if (oldCapacity > 0 && currentCapacity !== oldCapacity) {
              let scale = currentCapacity / oldCapacity;
              this.products.forEach((p) => {
                const matched = this._getMatchedPropertyQty(item.properties || {}, p);
                let oldQ = matched.qty; // per-unit
                const rawNum = Number(oldQ * scale * itemQty);
                const rounded = Number.isFinite(rawNum)
                  ? Math.max(0, Math.round(rawNum))
                  : 0;
                newQtys[p._key] += rounded;
                if (!p.hasDefault)
                  exactQtys.push({
                    key: p._key,
                    raw: rawNum,
                    rounded,
                    diff: Number.isFinite(rawNum) ? rawNum - rounded : 0,
                  });
              });
            } else {
              this.products.forEach((p) => {
                const matched = this._getMatchedPropertyQty(item.properties || {}, p);
                if (matched.qty > 0) {
                  // matched.qty 是 per-unit 值，乘以 itemQty 得到总量
                  newQtys[p._key] += matched.qty * itemQty;
                }
              });
            }
          } else {
            let propSum = 0;
            let tempQtys = {};
            this.products.forEach((p) => {
              const matched = this._getMatchedPropertyQty(item.properties || {}, p);
              if (matched.qty > 0) {
                tempQtys[p._key] = matched.qty; // per-unit
                propSum += matched.qty;
              }
            });

            if (propSum === currentCapacity && lineCapacity > 0) {
              this.products.forEach((p) => {
                // tempQtys 是 per-unit，乘以 itemQty 得到总量
                newQtys[p._key] += (tempQtys[p._key] || 0) * itemQty;
              });
            } else if (referenceQuantities?.totalPerUnit > 0) {
              const scale =
                currentCapacity > 0
                  ? currentCapacity / referenceQuantities.totalPerUnit
                  : 1;
              this.products.forEach((p) => {
                const basePerUnit = referenceQuantities.perUnit[p._key] || 0;
                if (basePerUnit <= 0) return;
                const rawNum = Number(
                  basePerUnit * Math.max(1, Number(item.quantity) || 0) * scale,
                );
                const rounded = Number.isFinite(rawNum)
                  ? Math.max(0, Math.round(rawNum))
                  : 0;
                newQtys[p._key] += rounded;
                if (!p.hasDefault) {
                  exactQtys.push({
                    key: p._key,
                    raw: rawNum,
                    rounded,
                    diff: Number.isFinite(rawNum) ? rawNum - rounded : 0,
                  });
                }
              });
            } else {
              let prods =
                item.bundle_config?.products?.products ||
                item.bundle_config?.products ||
                [];
              let totalAdded = 0;
              this.products.forEach((p) => {
                const match = this._getBundleConfigMatch(prods, p);
                if (match && parseInt(match.default_quantity || 0, 10) > 0) {
                  const dq = Math.max(
                    0,
                    Math.trunc(parseInt(match.default_quantity, 10) || 0),
                  );
                  let toAdd = dq * Math.max(1, Number(item.quantity) || 0);
                  if (
                    totalAdded + toAdd <= lineCapacity ||
                    lineCapacity === 0
                  ) {
                    newQtys[p._key] += toAdd;
                    totalAdded += toAdd;
                  }
                }
              });
              // 刚入车、行上还没有写入各子项数量时，metafield 里 default_quantity 可能全为 0；
              // 此时上面一圈加总仍为 0，但 lineCapacity（如 max_length * qty）> 0，UI 会卡在 0/N。
              // 回退：把本行「应选总数」按当前 products 均分，便于用户再微调；若后台配置了 default_quantity>0 则不会走这里。
              if (
                totalAdded === 0 &&
                lineCapacity > 0 &&
                this.products.length > 0
              ) {
                const sellableProducts = this.products.filter((p) =>
                  this.variantHasSellableStock(p),
                );
                if (sellableProducts.length === 0) return;
                const n = sellableProducts.length;
                const base = Math.floor(lineCapacity / n);
                let rem = lineCapacity - base * n;
                sellableProducts.forEach((p) => {
                  let add = base + (rem > 0 ? 1 : 0);
                  if (rem > 0) rem--;
                  newQtys[p._key] += add;
                });
              }
            }
          }
        });
      },

      /**
       * 修复缩放带来的四舍五入误差
       */
      _fixRoundingErrors(newQtys, exactQtys) {
        const sumKeys = (obj) =>
          Object.values(obj).reduce(
            (a, b) => a + (Number.isFinite(Number(b)) ? Math.max(0, Math.trunc(Number(b))) : 0),
            0,
          );
        let currentSum = sumKeys(newQtys);
        if (currentSum !== this.maxItems && exactQtys.length > 0) {
          const targetSum = this.maxItems;
          let guard = 0;
          // 每轮只调整 1，避免一次 for 对多个 key 连减导致总和“穿过去”变成异常/负数
          while (currentSum !== targetSum && guard++ < 5000) {
            let changed = false;
            if (currentSum < targetSum) {
              const sorted = [...exactQtys].sort((a, b) => b.diff - a.diff);
              for (const item of sorted) {
                newQtys[item.key] = Math.max(0, (newQtys[item.key] || 0) + 1);
                currentSum++;
                changed = true;
                break;
              }
            } else {
              const sorted = [...exactQtys].sort((a, b) => a.diff - b.diff);
              for (const item of sorted) {
                if ((newQtys[item.key] || 0) > 0) {
                  newQtys[item.key]--;
                  currentSum--;
                  changed = true;
                  break;
                }
              }
            }
            if (!changed) break;
          }
        }
        for (const k of Object.keys(newQtys)) {
          const v = Number(newQtys[k]);
          newQtys[k] = Number.isFinite(v) ? Math.max(0, Math.trunc(v)) : 0;
        }
      },

      /**
       * 强行重置缺货商品数量为0，并限制不能超过库存
       */
      _enforceInventoryLimits(newQtys) {
        let modified = false;
        this.products.forEach((p) => {
          let stockLimit = Infinity;
          if (p.inventory_management === "shopify" && p.inventory_policy === "deny") {
            stockLimit = typeof p.inventory_quantity === "number" ? p.inventory_quantity : 0;
          }

          if (p.available === false && stockLimit <= 0 && newQtys[p._key] > 0) {
            newQtys[p._key] = 0;
            modified = true;
          } else if (stockLimit !== Infinity && newQtys[p._key] > stockLimit) {
            newQtys[p._key] = Math.max(0, stockLimit);
            modified = true;
          }
        });
        return modified;
      },

      /**
       * 同步数量并计算是否需要保存
       */
      syncQuantities() {
        if (!this.products.length || !this.storeItems.length) return;

        const firstItem = this.storeItems[0];
        const savedSig = firstItem.properties?._bundle_line_sig || "";
        const currentSig = this.storeItemsSig;
        let newQtys = Object.fromEntries(this.products.map(p => [p._key, 0]));
        let exactQtys = [];
        let isUnchanged = savedSig === currentSig && firstItem.properties?._components;

        if (isUnchanged) this._syncUnchangedQuantities(newQtys);
        else this._syncChangedQuantities(newQtys, exactQtys);

        this._fixRoundingErrors(newQtys, exactQtys);
        let outOfStockModified = this._enforceInventoryLimits(newQtys);

        for (const p of this.products) {
          const v = Number(newQtys[p._key]);
          newQtys[p._key] = Number.isFinite(v) ? Math.max(0, Math.trunc(v)) : 0;
        }

        let currentSum = Object.values(newQtys).reduce(
          (a, b) => a + (Number.isFinite(Number(b)) ? Math.max(0, Math.trunc(Number(b))) : 0),
          0,
        );
        if (this.maxItems > 0 && currentSum > this.maxItems) {
          let over = currentSum - this.maxItems;
          [false, true].forEach(allowDefault => {
            for (let p of this.products) {
              if (over <= 0) break;
              if (newQtys[p._key] > 0 && (allowDefault || !p.hasDefault)) {
                let toRemove = Math.min(newQtys[p._key], over);
                newQtys[p._key] -= toRemove;
                over -= toRemove;
                outOfStockModified = true;
              }
            }
          });
        }

        this.quantities = newQtys;

        // 终极修复：彻底切断无脑保存死循环！
        // 只有当第一次加购进来还没生成子商品时，或者因为库存不足强制拦截了数量，才允许保存！
        const needsInit = this.storeItems.some(item => !(item.properties && item.properties._components));
        if (outOfStockModified || needsInit) {
          this.debouncedSave(outOfStockModified);
        }
      },

      updateQuantity(key, newQty) {
        newQty = Math.max(0, Math.trunc(Number(newQty) || 0));
        const prod = this.products.find((p) => p._key === key);
        const currentQty = Math.max(0, Math.trunc(Number(this.quantities[key]) || 0));

        if (prod) {
          let stockLimit = Infinity;
          if (prod.inventory_management === "shopify" && prod.inventory_policy === "deny") {
            stockLimit = typeof prod.inventory_quantity === "number" ? prod.inventory_quantity : 0;
          }

          if (prod.available === false && stockLimit <= 0 && newQty > currentQty) return;
          if (newQty > stockLimit) newQty = Math.max(0, stockLimit);
        }

        if (newQty > currentQty && this.maxItems > 0) {
          const other = this.currentTotal - currentQty;
          const maxForThis = this.maxItems - other;
          if (newQty > maxForThis) newQty = maxForThis;
          if (newQty <= currentQty) return;
        }
        this.quantities = { ...this.quantities, [key]: newQty };
        this.debouncedSave();
      },

      debouncedSave(needsRefresh = false) {
        if (needsRefresh) this._needsRefreshPending = true;
        clearTimeout(this._saveTimeout);

        if (!this._isSavePendingFlag) {
          this._isSavePendingFlag = true;
          Alpine.store("cart")._unsavedBundleCount++;
        }

        // 不要在这里立即设置 isUpdating = true，否则用户快速点击时会感觉到卡顿/锁定
        // 我们将其放在实际执行 saveToCart 的时候，让连续点击可以无缝进行
        this._saveTimeout = setTimeout(() => this.saveToCart(), 800);
      },

      /**
       * 计算并组织填充目标数组
       */
      _buildItemsToFill() {
        let itemsToFill = [...this.storeItems].map((item, index) => {
          const cfg = item.bundle_config || {};
          let max1 = parseInt(cfg.max_length || cfg.max_items || 0, 10) || 0;
          let max2 = parseInt(cfg.min_length || cfg.min_items || 0, 10) || 0;
          let maxPerUnit = Math.max(max1, max2);
          const propsMax =
            parseInt(item.properties?._bundle_max_qty || "0", 10) || 0;

          if (maxPerUnit === 0) {
            if (propsMax > 0 && item.quantity > 0) {
              maxPerUnit = Math.round(propsMax / item.quantity);
            } else if (Array.isArray(cfg)) {
              maxPerUnit = cfg.length;
            }
          }
          const capacity = maxPerUnit > 0 ? maxPerUnit * item.quantity : propsMax;
          const hasSavedBundleState =
            !!item.properties?._bundle_line_sig && !!item.properties?._components;
          return {
            item,
            maxPerUnit,
            capacity,
            allocated: {},
            originalIndex: index,
            isNewlyAdded: !hasSavedBundleState,
          };
        });
        // 优先更新新加购（尚未写入 bundle 配置）的主商品，再按购物车原始顺序
        itemsToFill.sort(
          (a, b) => {
            if (a.isNewlyAdded !== b.isNewlyAdded) {
              return a.isNewlyAdded ? -1 : 1;
            }
            return a.originalIndex - b.originalIndex;
          }
        );
        return itemsToFill;
      },

      _mergeFillTargetsByVariant(itemsToFill) {
        // 核心修复：保存配置时也绝对不合并主商品，确保每个包裹独立！
        return itemsToFill.map(target => ({
          ...target,
          item: { ...(target.item || {}) },
          allocated: { ...(target.allocated || {}) },
          keysToRemove: []
        }));
      },

      /**
       * 分配商品数量到主商品上
       */
      _allocateQuantities(itemsToFill, availableQtys) {
        this.products.forEach((p) => {
          availableQtys[p._key] = Math.max(
            0,
            Math.trunc(Number(availableQtys[p._key]) || 0),
          );
        });
        const referenceQuantities = this._getReferencePerUnitQuantities();
        if (referenceQuantities?.totalPerUnit > 0) {
          const referenceTotals = {};
          const plannedAllocations = itemsToFill.map((fillTarget) => {
            const allocated = {};
            const roundingEntries = [];
            const itemQty = Math.max(1, Number(fillTarget.item?.quantity) || 0);
            const scale =
              fillTarget.maxPerUnit > 0
                ? fillTarget.maxPerUnit / referenceQuantities.totalPerUnit
                : 1;
            let allocatedSum = 0;

            this.products.forEach((p) => {
              const perUnitQty = referenceQuantities.perUnit[p._key] || 0;
              if (perUnitQty <= 0) return;
              const raw = perUnitQty * itemQty * scale;
              const rounded = Math.round(raw);
              if (rounded > 0) {
                allocated[p._key] = rounded;
                allocatedSum += rounded;
                roundingEntries.push({
                  key: p._key,
                  diff: raw - rounded,
                });
              }
            });

            let remaining = fillTarget.capacity - allocatedSum;
            if (remaining !== 0 && roundingEntries.length > 0) {
              const ordered = [...roundingEntries].sort((a, b) =>
                remaining > 0 ? b.diff - a.diff : a.diff - b.diff,
              );
              let guard = 0;
              while (remaining !== 0 && guard++ < 5000) {
                let changed = false;
                for (const entry of ordered) {
                  if (remaining > 0) {
                    allocated[entry.key] = Math.max(0, (allocated[entry.key] || 0) + 1);
                    remaining--;
                    changed = true;
                  } else if ((allocated[entry.key] || 0) > 0) {
                    allocated[entry.key] -= 1;
                    if (allocated[entry.key] <= 0) delete allocated[entry.key];
                    remaining++;
                    changed = true;
                  }
                  if (remaining === 0) break;
                }
                if (!changed) break;
              }
            }

            Object.entries(allocated).forEach(([key, qty]) => {
              referenceTotals[key] = (referenceTotals[key] || 0) + qty;
            });

            return allocated;
          });

          const matchesReference = this.products.every(
            (p) => (referenceTotals[p._key] || 0) === (availableQtys[p._key] || 0),
          );

          if (matchesReference) {
            itemsToFill.forEach((fillTarget, index) => {
              fillTarget.allocated = plannedAllocations[index];
            });
            return;
          }
        }

        // === 不从其他 item 抢数量，每个 item 只从自己 properties 读取 ===
        itemsToFill.forEach((fillTarget) => {
          const item = fillTarget.item;
          const itemQty = Math.max(1, Number(item?.quantity) || 0);
          const itemProps = item?.properties || {};
          const allocated = {};
          this.products.forEach((p) => {
            const matched = this._getMatchedPropertyQty(itemProps, p);
            if (matched.qty > 0) {
              allocated[p._key] = matched.qty * itemQty;
            }
          });
          fillTarget.allocated = allocated;
        });
      },

      /**
       * 计算组总数并发出 Shopify API 更新请求
       */
      async _processUpdates(itemsToFill) {
        const effectiveItems = itemsToFill.map((target) => target.item);
        const lineSig = this._buildLineSigFromItems(effectiveItems);
        let groupItemQtyStr = String(
          effectiveItems.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0),
        );
        let groupCurrentTotal = 0, groupFreeTotal = 0;
        let lineRemovals = {};

        this.products.forEach((p) => {
          if (this.quantities[p._key] > 0) {
            groupCurrentTotal += this.quantities[p._key];
            if (!p.hasDefault) groupFreeTotal += this.quantities[p._key];
          }
        });
        let latestCartData = null;

        // 1. 核心修复：先执行清理。遍历收集所有要移除的行，立刻调用 updatecartlines
        for (let i = 0; i < itemsToFill.length; i++) {
          (itemsToFill[i].keysToRemove || []).forEach((key) => {
            if (key) lineRemovals[key] = 0;
          });
        }
        if (Object.keys(lineRemovals).length > 0) {
          try {
            latestCartData = await updatecartlines(lineRemovals);
          } catch(e) {
            console.warn("[ProcessUpdates] 删除旧项失败", e);
          }
        }

        // 2. 然后再循环更新主项数量与属性
        for (let i = 0; i < itemsToFill.length; i++) {
          let { item, allocated, capacity } = itemsToFill[i];
          let itemId = item.key || item.id || item.variant_id;
          if (!itemId) continue;
          itemId = String(itemId);

          // 兜底：由于提前执行了删除，主项的 Key 可能已失效，从 latestCartData 找回
          if (latestCartData && latestCartData.items) {
            let matched = null;
            if (item.properties && item.properties._bundle_id) {
              matched = latestCartData.items.find(cartItem => 
                cartItem.properties && String(cartItem.properties._bundle_id) === String(item.properties._bundle_id)
              );
            }
            if (!matched) {
               matched = latestCartData.items.find(cartItem => String(cartItem.variant_id) === String(item.variant_id));
            }
            if (matched && matched.key) {
              itemId = String(matched.key);
              item.key = matched.key;
            }
          }

          let itemProps = Object.assign({}, item.properties || {});
          
          this.products.forEach((p) => {
            const keysToDelete = new Set([
              p._propertyLabel, p.title, p.variant_title, p.sku, String(p.variant_id || ""), String(p.id || "")
            ]);
            const matchedKey = this._findMatchingPropertyKey(itemProps, p);
            if (matchedKey) keysToDelete.add(matchedKey);
            keysToDelete.forEach((key) => {
              if (!key) return;
              delete itemProps[key];
              delete itemProps["_" + key];
            });
          });

          let compsConfig = [];
          let freeTotal = 0, currentTotalForThisItem = 0;

          const lineQty = Math.max(1, Number(item.quantity) || 0);
          const compsById = new Map();
          this.products.forEach((p) => {
            let qty = allocated[p._key] || 0;
            if (qty > 0) {
              const cid = p.variant_id || p.id;
              const key = String(cid);
              if (compsById.has(key)) {
                compsById.get(key).totalQty += qty;
              } else {
                compsById.set(key, {
                  id: cid,
                  totalQty: qty,
                  propertyKey: this._getPreferredPropertyKey(p),
                  hasDefault: p.hasDefault,
                });
              }
            }
          });
          compsById.forEach((entry) => {
            const perUnitQty = Math.max(1, Math.round(entry.totalQty / lineQty));
            itemProps["_qty_" + entry.propertyKey] = String(perUnitQty);
            compsConfig.push({ id: entry.id, quantity: perUnitQty });
            currentTotalForThisItem += entry.totalQty;
            if (!entry.hasDefault) freeTotal += entry.totalQty;
          });

          Object.assign(itemProps, {
            _components: compsConfig.length > 0 ? JSON.stringify(compsConfig) : "",
            _bundle_total_qty: String(currentTotalForThisItem),
            _bundle_free_total_qty: String(freeTotal),
            _bundle_max_qty: String(capacity),
            _bundle_item_qty: groupItemQtyStr,
            _bundle_line_sig: lineSig,
            _group_total_qty: String(groupCurrentTotal),
            _group_free_total_qty: String(groupFreeTotal),
            _group_max_qty: String(this.maxItems)
          });
          delete itemProps._bundle_id;

          const currentProps = item.properties || {};
          const currentLineQuantity =
            Number(
              this.storeItems.find(
                (storeItem) => String(storeItem?.key || storeItem?.id || storeItem?.variant_id) === itemId,
              )?.quantity,
            ) || 0;
          const targetLineQuantity = Number(item.quantity) || 0;
          const isPropsUnchanged = (() => {
            const keys = new Set([...Object.keys(currentProps), ...Object.keys(itemProps)]);
            for (const k of keys) {
              const curVal = currentProps[k] == null ? "" : String(currentProps[k]);
              const nextVal = itemProps[k] == null ? "" : String(itemProps[k]);
              if (curVal !== nextVal) return false;
            }
            return true;
          })();
          const isLineUnchanged = isPropsUnchanged && currentLineQuantity === targetLineQuantity;

          const alreadyFilled =
            capacity > 0 &&
            Number(currentProps._bundle_total_qty || 0) === capacity &&
            String(currentProps._bundle_line_sig || "") === lineSig &&
            currentLineQuantity === targetLineQuantity;

          if (alreadyFilled && isLineUnchanged) { continue; }
          if (isLineUnchanged) { continue; }

          const res = await updatecartline(itemId, { quantity: item.quantity, properties: itemProps });
          latestCartData = res;
          item.properties = itemProps;
        }
        return latestCartData;
      },

      _saveAbortController: null,

      /**
       * 将当前配置保存到购物车
       */
      async saveToCart() {
        if (!this.storeItems.length) return;

        if (Alpine.store("cart")._isUpdatePending) {
          this.debouncedSave();
          // 重置 isUpdating 防止卡死
          if (!Alpine.store("cart").isLoading && !Alpine.store("cart")._syncingCart) {
            Alpine.store("cart").isUpdating = false;
          }
          return;
        }

        if (this.isSaving) {
          this._pendingSave = true;
          return;
        }

        this.isSaving = true;
        Alpine.store("cart").isUpdating = true;
        this._pendingSave = false;
        this._skipIsUpdatingReset = false;

        // 备份一下现有的数量快照，如果接口报错我们可以恢复
        const previousQuantities = JSON.stringify(this.quantities);

        let attempts = 0;
        const maxAttempts = 3;
        let success = false;

        while (attempts < maxAttempts && !success) {
          attempts++;
          try {
            let itemsToFill = this._buildItemsToFill();
            let availableQtys = Object.fromEntries(this.products.map(p => [p._key, this.quantities[p._key] || 0]));

            this._allocateQuantities(itemsToFill, availableQtys);
            itemsToFill = this._mergeFillTargetsByVariant(itemsToFill);
            const updatedCart = await this._processUpdates(itemsToFill);

            // 根治：保存成功后不直接使用 change/update 的返回体，统一强制重拉 cart.js + bundle section
            if (updatedCart?.items) {
              await Alpine.store("cart").fetchCart(false, { force: true });
            }
            success = true;
          } catch (e) {
            const errorStr = String(e.message || "").toLowerCase();
            const isInvalidId = errorStr.includes("no valid id") || errorStr.includes("invalid") || errorStr.includes("expired");

            if (isInvalidId && attempts < maxAttempts) {
              console.warn("Cart key expired, refetching and retrying... Attempt:", attempts);
              // 这里非常关键：必须使用 fetchCart(false) 重新从服务器拉取包含最新 Key 的购物车数据
              await Alpine.store("cart").fetchCart(false, { force: true });
              continue; // 进入下一次 while 循环重新重试保存
            }

            // 其它错误或超出重试次数，只将库存/售罄的错误展示给用户，避免出现令人费解的技术报错
            let msgToShow = "";
            const errorStrLower = errorStr.toLowerCase();
            if (errorStrLower.includes("sold out") || errorStrLower.includes("inventory") || errorStrLower.includes("stock")) {
              msgToShow = e.message || "Some items are sold out or out of stock.";
            }
            Alpine.store("cart").showError(msgToShow);

            // 恢复成修改前的数值
            this.quantities = JSON.parse(previousQuantities);
            await Alpine.store("cart").fetchCart(true, { force: true });
            break;
          }
        }

        this.isSaving = false;
        this._isSavePendingFlag = false;
        Alpine.store("cart")._unsavedBundleCount = Math.max(0, Alpine.store("cart")._unsavedBundleCount - 1);
        if (this._pendingSave) {
          this._pendingSave = false;
          this.debouncedSave();
        }
        if (!Alpine.store("cart").isLoading && !Alpine.store("cart")._syncingCart) {
          Alpine.store("cart").isUpdating = false;
        }
      }
    }));
  }

  if (window.Alpine) {
    initCustomCartDrawer();
  } else {
    document.addEventListener("alpine:init", initCustomCartDrawer);
  }

} // end disabled legacy drawer block

/**
 * 批量 GraphQL 获取 variant 信息（一次请求替代多次 section render）
 * @param {number[]} variantIds
 * @returns {Promise<Map<number, object>>} variant_id → data
 */
async function _fetchVariantsByIds(variantIds) {
  const ids = [...new Set(variantIds.filter(Boolean))];
  if (!ids.length) return new Map();

  const cache =
    window.__YOUWEI_VARIANT_CACHE__ || (window.__YOUWEI_VARIANT_CACHE__ = new Map());
  const result = new Map();
  const missing = [];

  for (const id of ids) {
    const cached = cache.get(id);
    if (cached) { result.set(id, cached); }
    else { missing.push(id); }
  }

  if (!missing.length) return result;

  try {
    const gids = missing.map((id) => `"gid://shopify/ProductVariant/${id}"`);
    const query = `query {
      nodes(ids: [${gids.join(",")}]) {
        ... on ProductVariant {
          id sku title availableForSale
          quantityAvailable
          price { amount currencyCode }
          compareAtPrice { amount currencyCode }
          image { url(transform: {maxWidth: 240}) }
          product {
            id title handle
            featuredImage { url(transform: {maxWidth: 240}) }
          }
        }
      }
    }`;

    const res = await fetch(_storefrontEndpoint(), {
      method: "POST",
      headers: _storefrontHeaders(),
      body: JSON.stringify({ query }),
    });
    if (!res.ok) return result;
    const body = await res.json();
    const nodes = body?.data?.nodes || [];

    for (const node of nodes) {
      if (!node?.id) continue;
      const numId = parseInt(String(node.id).split("/").pop(), 10);
      if (!numId) continue;

      const image = node.image?.url || node.product?.featuredImage?.url || "";
      const invQty = node.quantityAvailable != null ? node.quantityAvailable : null;

      const entry = {
        id: numId,
        variant_id: numId,
        sku: node.sku || "",
        title: node.product?.title || "",
        variant_title: node.title && node.title !== "Default Title" ? node.title : "",
        image,
        price: node.price?.amount || null,
        available: node.availableForSale !== false,
        inventory_quantity: invQty ?? null,
        inventory_policy: invQty != null ? "deny" : "deny",
        inventory_management: invQty != null ? "shopify" : null,
      };
      cache.set(numId, entry);
      result.set(numId, entry);
    }
  } catch (_) {
    // GraphQL 失败时不阻塞，调用方会用已有数据兜底
  }
  return result;
}

// --- 购物车：读 Ajax / 写 GraphQL ---

function _cartStoreRoot() {
  return (typeof window !== "undefined" && window.Shopify?.routes?.root) || "/";
}

function _cartUrl(endpoint) {
  const base = String(_cartStoreRoot()).replace(/\/+$/, "");
  const ep = String(endpoint).replace(/^\//, "");
  return `${base === "" ? "" : base}/${ep}`;
}

// ============================================================
//  Storefront API GraphQL — 批量商品 + Cart 写操作
// ============================================================
const _STOREFRONT_API_VERSION = "2026-04";
const _STOREFRONT_TOKEN = "a1a858399197f1f8ed9c42a90ca2cd33";

function _storefrontEndpoint() {
  return `${window.location.origin}/api/${_STOREFRONT_API_VERSION}/graphql.json`;
}

function _storefrontHeaders() {
  return {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": window.YOUWEI_STOREFRONT_TOKEN || _STOREFRONT_TOKEN,
  };
}

function _cartApiGetCartGid() {
  try {
    const store = Alpine.store("cart");
    if (store) {
      const d = store.data || {};
      const id = d.id || d.token || "";
      if (id) {
        const s = String(id);
        return s.startsWith("gid://") ? s : `gid://shopify/Cart/${s}`;
      }
    }
    const m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
    if (m && m[1]) return `gid://shopify/Cart/${m[1].trim()}`;
    return null;
  } catch (_) { return null; }
}

function _cartApiToLineGid(key) {
  if (!key) return null;
  const str = String(key).trim();
  // 核心修复：如果已经是完整 GID，直接原样使用；防止截断导致 Shopify 报错 line does not exist
  if (str.startsWith("gid://shopify/CartLine/")) return str;
  const seg = str.split(":")[0];
  return seg ? `gid://shopify/CartLine/${seg}` : null;
}

/**
 * 查：获取当前购物车 JSON
 * @returns {Promise<object>}
 */
async function _migrateLegacyCart() {
  try {
    const legacyRes = await fetch(`${_cartStoreRoot()}cart.js`, { credentials: "same-origin" });
    if (!legacyRes.ok) return null;
    const legacyCart = await legacyRes.json();
    if (!legacyCart?.items?.length) return null;

    // 1. 创建新的 Storefront API 购物车
    const createData = await _cartApiGql(`mutation { cartCreate(input: {}) { cart { id } userErrors { field message } } }`);
    const newCart = createData?.cartCreate?.cart;
    if (!newCart?.id) return null;

    // 2. 将旧商品迁移到新购物车
    const lines = legacyCart.items.map((item) => ({
      merchandiseId: `gid://shopify/ProductVariant/${item.variant_id || item.id}`,
      quantity: item.quantity || 1,
      attributes: Object.entries(item.properties || {})
        .filter(([, v]) => v != null && v !== "")
        .map(([k, v]) => ({ key: k, value: String(v) })),
    }));

    const addData = await _cartApiGql(_GQL_LINES_ADD, { cartId: newCart.id, lines });
    const result = addData?.cartLinesAdd?.cart;
    if (!result) return null;

    // 3. 覆盖旧 cart cookie，后续走新 token
    const token = String(result.id).split("/").pop();
    document.cookie = `cart=${token}; path=/; max-age=31536000; SameSite=Lax`;

    return result;
  } catch (_) { return null; }
}

async function getcart() {
  let cartGid = _cartApiGetCartGid();
  let cart;

  if (!cartGid) {
    // 无购物车 → 创建新的 Storefront API 购物车
    cart = await _cartApiEnsureCartGidAndFetch();
    if (!cart) throw new Error("getcart: unable to create cart");
  } else {
    try {
      cart = await _cartApiGqlFetchCart(cartGid);
      if (!cart) {
        // GraphQL 查不到（可能是旧 Ajax cart）→ 一次性迁移
        cart = await _migrateLegacyCart();
      }
      if (!cart) {
        // 无旧数据或迁移失败 → 创建新空购物车
        cart = await _cartApiEnsureCartGidAndFetch();
      }
    } catch (_) {
      cart = await _cartApiEnsureCartGidAndFetch();
    }
    if (!cart) throw new Error("getcart: unable to load cart");
  }

  const cartData = _cartApiNormalizeCart(cart);

  // 补充 bundle section 数据
  try {
    const bundleRes = await fetch(`${_cartStoreRoot()}?section_id=cart-bundle-data`);
    if (bundleRes.ok) {
      const bundleHtml = await bundleRes.text();
      const bundleData = youwei_parse_section_html_json(bundleHtml);
      if (bundleData && Array.isArray(bundleData.items)) {
        const byVariantId = new Map();
        bundleData.items.forEach((x) => { if (x?.id) byVariantId.set(x.id, x); });
        cartData.items = cartData.items.map((item) => {
          const matched = byVariantId.get(item.variant_id) || byVariantId.get(item.id);
          if (!matched) return item;
          if (matched.bundle_config != null) {
            try {
              item.bundle_config =
                typeof matched.bundle_config === "string"
                  ? JSON.parse(matched.bundle_config)
                  : matched.bundle_config;
            } catch {
              item.bundle_config = matched.bundle_config;
            }
          }
          if (matched.properties && typeof matched.properties === "object") {
            item.properties = { ...(item.properties || {}), ...matched.properties };
          }
          return item;
        });
      }
    }
  } catch { /* bundle section 失败不影响基础购物车返回 */ }

  return cartData;
}

async function _cartApiEnsureCartGidAndFetch() {
  const data = await _cartApiGql(`mutation { cartCreate(input: {}) { cart { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } userErrors { field message } } }`);
  return data?.cartCreate?.cart || null;
}

async function _cartApiGqlFetchCart(cartGid) {
  const query = `query getCart($cartId: ID!) { cart(id: $cartId) { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } }`;
  const data = await _cartApiGql(query, { cartId: cartGid });
  return data?.cart || null;
}

// ============================================================
//  Cart 写操作 — 全部走 GraphQL Storefront API（避免 Ajax 429 限流）
//  getcart() 读操作保持 Ajax（兼容性好）
// ============================================================

async function _cartApiEnsureCartGid() {
  let gid = _cartApiGetCartGid();
  if (gid) return gid;
  const q = `mutation { cartCreate(input: {}) { cart { id } userErrors { field message } } }`;
  const data = await _cartApiGql(q);
  const cart = data?.cartCreate?.cart;
  if (!cart?.id) throw new Error("cartCreate failed");
  return String(cart.id);
}

async function _cartApiGql(query, variables) {
  const res = await fetch(_storefrontEndpoint(), {
    method: "POST",
    headers: _storefrontHeaders(),
    body: JSON.stringify({ query, variables }),
  });
  if (!res.ok) throw new Error(`GraphQL: ${res.status}`);
  const body = await res.json();
  if (body.errors?.length) throw new Error(body.errors.map((e) => e.message).join("; "));
  return body.data;
}

function _cartApiNormalizeCart(cart) {
  if (!cart) return { items: [], item_count: 0, total_price: 0, currency: "CNY" };
  const items = (cart.lines?.edges || []).map((edge) => {
    const node = edge.node;
    const v = node.merchandise;
    const lineId = String(node.id).split("/").pop();
    const vid = parseInt(String(v.id).split("/").pop(), 10);
    const pid = parseInt(String(v.product.id).split("/").pop(), 10);
    const qty = node.quantity;
    const priceCents = Math.round(parseFloat(v.price?.amount || "0") * 100);
    const linePriceCents = Math.round(parseFloat(node.cost?.totalAmount?.amount || "0") * 100);
    const compareAtCents = v.compareAtPrice?.amount
      ? Math.round(parseFloat(v.compareAtPrice.amount) * 100) : null;
    const itemCompareAtCents = node.cost?.compareAtAmountPerQuantity?.amount
      ? Math.round(parseFloat(node.cost.compareAtAmountPerQuantity.amount) * 100) : compareAtCents;
    const properties = {};
    (node.attributes || []).forEach((a) => { properties[a.key] = a.value; });
    const img = v.image?.url || v.product?.featuredImage?.url || "";
    return {
      id: vid, key: lineId, variant_id: vid, product_id: pid, quantity: qty,
      title: v.product.title, product_title: v.product.title,
      variant_title: v.title && v.title !== "Default Title" ? v.title : "",
      price: priceCents, original_price: itemCompareAtCents || priceCents,
      final_line_price: linePriceCents, line_price: linePriceCents,
      original_line_price: itemCompareAtCents ? itemCompareAtCents * qty : linePriceCents,
      total_discount: 0, discounts: [], properties,
      image: img, featured_image: img ? { url: img } : null,
      available: v.availableForSale !== false, sku: v.sku || "",
      handle: v.product.handle || "",
      url: v.product.handle ? `/products/${v.product.handle}` : "",
      compare_at_price: itemCompareAtCents,
      product_has_only_default_variant: false, vendor: "",
      requires_shipping: true, taxable: true, grams: 0,
      unit_price: null, unit_price_measurement: { measured_type: null, quantity_value: 0, quantity_unit: "", reference_value: 0, reference_unit: "" },
      line_level_discount_allocations: [], line_level_total_discount: 0, product_type: "",
    };
  });
  const totalPrice = cart.cost?.totalAmount?.amount
    ? Math.round(parseFloat(cart.cost.totalAmount.amount) * 100) : 0;
  const subtotalPrice = cart.cost?.subtotalAmount?.amount
    ? Math.round(parseFloat(cart.cost.subtotalAmount.amount) * 100) : 0;
  const currency = cart.cost?.totalAmount?.currencyCode || "CNY";
  return {
    token: String(cart.id || "").split("/").pop(), id: cart.id,
    items, item_count: cart.totalQuantity || 0,
    items_subtotal_price: subtotalPrice, total_price: totalPrice,
    original_total_price: subtotalPrice, total_discount: 0, total_weight: 0,
    currency, note: null, attributes: {},
  };
}

// ---- GraphQL Cart 变更 ----

const _GQL_CART_CREATE = `mutation cartCreate { cartCreate(input: {}) { cart { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } userErrors { field message } } }`;

const _GQL_CART_CREATE_WITH_CHECKOUT = `mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }`;

function _cartLineAttributesFromProps(props) {
  return Object.entries(props || {})
    .filter(([, value]) => value != null && value !== "")
    .map(([key, value]) => ({ key, value: String(value) }));
}

async function youweiBuyNow(lines) {
  if (!Array.isArray(lines) || lines.length === 0) {
    throw new Error("youweiBuyNow: lines must be a non-empty array");
  }
  const data = await _cartApiGql(_GQL_CART_CREATE_WITH_CHECKOUT, { input: { lines } });
  const result = data?.cartCreate;
  if (!result) {
    throw new Error("youweiBuyNow: cartCreate returned no result");
  }
  if (result.userErrors?.length) {
    throw new Error(result.userErrors.map((error) => error.message).join("; "));
  }
  const cart = result.cart;
  if (!cart) {
    throw new Error("youweiBuyNow: cartCreate returned no cart");
  }
  if (cart.checkoutUrl) {
    return cart.checkoutUrl;
  }

  const cartToken = String(cart.id || "").split('/').pop();
  if (!cartToken) {
    throw new Error("youweiBuyNow: checkoutUrl missing and cart token unavailable");
  }

  document.cookie = `cart=${cartToken}; path=/; max-age=31536000; SameSite=Lax`;
  return `${window.Shopify?.routes?.root || ''}checkout`;
}

window.youweiBuyNow = window.youweiBuyNow || youweiBuyNow;

const _GQL_LINES_UPDATE = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) { cartLinesUpdate(cartId: $cartId, lines: $lines) { cart { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } userErrors { field message } } }`;

const _GQL_LINES_REMOVE = `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) { cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { cart { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } userErrors { field message } } }`;

const _GQL_LINES_ADD = `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) { cartLinesAdd(cartId: $cartId, lines: $lines) { cart { id totalQuantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } } lines(first:250) { edges { node { id quantity merchandise { ... on ProductVariant { id title sku price { amount currencyCode } availableForSale compareAtPrice { amount currencyCode } image { url } product { id title handle featuredImage { url } } } } attributes { key value } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } compareAtAmountPerQuantity { amount currencyCode } } } } } } userErrors { field message } } }`;

// --- 对外 API（签名与旧版 Ajax 完全兼容）---

async function addcartitems(items, options = {}) {
  const list = Array.isArray(items) ? items : [items];
  if (!list.length) throw new Error("addcartitems: items must be a non-empty array or object");
  const cartGid = await _cartApiEnsureCartGid();
  const lines = list.map((item) => {
    const vid = item.id || item.variant_id;
    const line = { merchandiseId: `gid://shopify/ProductVariant/${vid}`, quantity: item.quantity || 1 };
    if (item.properties) {
      line.attributes = Object.entries(item.properties)
        .filter(([, v]) => v != null && v !== "")
        .map(([k, v]) => ({ key: k, value: String(v) }));
    }
    return line;
  });
  const data = await _cartApiGql(_GQL_LINES_ADD, { cartId: cartGid, lines });
  const result = data?.cartLinesAdd;
  if (result?.userErrors?.length) throw new Error(result.userErrors.map((e) => e.message).join("; "));
  return _cartApiNormalizeCart(result?.cart);
}

async function updatecartlines(updates, options = {}) {
  if (!updates || typeof updates !== "object" || Array.isArray(updates))
    throw new Error("updatecartlines: updates must be a plain object");
  const normalized = Object.fromEntries(
    Object.entries(updates).filter(([k]) => k != null && String(k).trim() !== ""));
  if (!Object.keys(normalized).length) return {};
  const cartGid = _cartApiGetCartGid();
  if (!cartGid) throw new Error("updatecartlines: cart not available");
  const toUpdate = []; const toRemove = [];
  for (const [key, qty] of Object.entries(normalized)) {
    const gid = _cartApiToLineGid(key);
    if (!gid) continue;
    if (qty > 0) toUpdate.push({ id: gid, quantity: qty });
    else toRemove.push(gid);
  }
  let resultCart;
  if (toUpdate.length) {
    const data = await _cartApiGql(_GQL_LINES_UPDATE, { cartId: cartGid, lines: toUpdate });
    const r = data?.cartLinesUpdate;
    if (r?.userErrors?.length) throw new Error(r.userErrors.map((e) => e.message).join("; "));
    resultCart = r?.cart;
  }
  if (toRemove.length) {
    const data = await _cartApiGql(_GQL_LINES_REMOVE, { cartId: cartGid, lineIds: toRemove });
    const r = data?.cartLinesRemove;
    if (r?.userErrors?.length) {
      // 容错过滤：如果 Shopify 提示该行已不存在，说明目标已达成，直接放行，绝不阻断主商品数量更新
      const realErrors = r.userErrors.filter(e => !String(e.message || "").toLowerCase().includes("does not exist"));
      if (realErrors.length) throw new Error(realErrors.map((e) => e.message).join("; "));
    }
    resultCart = r?.cart || resultCart;
  }
  if (resultCart) return _cartApiNormalizeCart(resultCart);
  throw new Error("updatecartlines: no updates or removals performed");
}

async function updatecartline(lineKey, fields = {}, options = {}) {
  if (lineKey == null || lineKey === "") throw new Error("updatecartline: lineKey is required");
  let { quantity, properties } = fields;
  if (quantity == null && properties == null)
    throw new Error("updatecartline: pass quantity and/or properties");
  if (properties != null && (typeof properties !== "object" || Array.isArray(properties)))
    throw new Error("updatecartline: properties must be a plain object");
  if (quantity == null) {
    const cart = await getcart();
    const keyStr = String(lineKey);
    const item = cart.items?.find((i) => i && (String(i.key) === keyStr || String(i.id) === keyStr));
    if (!item) throw new Error("updatecartline: no line item matches lineKey");
    quantity = item.quantity;
  }
  const cartGid = _cartApiGetCartGid();
  if (!cartGid) throw new Error("updatecartline: cart not available");
  const lineGid = _cartApiToLineGid(lineKey);
  if (!lineGid) throw new Error(`updatecartline: cannot construct GID for line ${lineKey}`);
  const lineUpdate = { id: lineGid, quantity };
  if (properties != null) {
    lineUpdate.attributes = Object.entries(properties)
      .filter(([, v]) => v != null && v !== "")
      .map(([k, v]) => ({ key: k, value: String(v) }));
  }
  const data = await _cartApiGql(_GQL_LINES_UPDATE, { cartId: cartGid, lines: [lineUpdate] });
  const result = data?.cartLinesUpdate;
  if (result?.userErrors?.length) throw new Error(result.userErrors.map((e) => e.message).join("; "));
  return _cartApiNormalizeCart(result?.cart);
}

async function updatecartproperties(lineKey, properties, options = {}) {
  return updatecartline(lineKey, { properties }, options);
}

async function removecartline(lineKey, options = {}) {
  return updatecartline(lineKey, { quantity: 0 }, options);
}

async function clearcart(options = {}) {
  const cartGid = _cartApiGetCartGid();
  if (!cartGid) throw new Error("clearcart: cart not available");
  const store = Alpine.store("cart");
  const lineIds = (store?.data?.items || [])
    .map((item) => _cartApiToLineGid(item.key)).filter(Boolean);
  if (lineIds.length) {
    const data = await _cartApiGql(_GQL_LINES_REMOVE, { cartId: cartGid, lineIds });
    const result = data?.cartLinesRemove;
    if (result?.userErrors?.length) throw new Error(result.userErrors.map((e) => e.message).join("; "));
    return _cartApiNormalizeCart(result?.cart);
  }
  return _cartApiNormalizeCart({ id: cartGid, totalQuantity: 0, lines: { edges: [] }, cost: {} });
}

// --- 本文件 / bundle-configurator / cart-items 用到的购物车行 properties：键名 + 生成函数 ---

/**
 * 行属性键名（与 theme 内读写保持一致，避免手写字符串拼错）
 * @readonly
 */
var YOUWEI_CART_LINE_PROP = window.YOUWEI_CART_LINE_PROP || Object.freeze({
  IS_COMPONENT: "_is_component",
  PARENT_KEY: "_parent_key",
  PARENT_BUNDLE_ID: "_parent_bundle_id",
  BUNDLE_ID: "_bundle_id",
  COMPONENTS: "_components",
  BUNDLE_TOTAL_QTY: "_bundle_total_qty",
  BUNDLE_FREE_TOTAL_QTY: "_bundle_free_total_qty",
  BUNDLE_MAX_QTY: "_bundle_max_qty",
  BUNDLE_ITEM_QTY: "_bundle_item_qty",
  BUNDLE_LINE_SIG: "_bundle_line_sig",
  GROUP_TOTAL_QTY: "_group_total_qty",
  GROUP_FREE_TOTAL_QTY: "_group_free_total_qty",
  GROUP_MAX_QTY: "_group_max_qty",
  PART_OF_BUNDLE: "_Part of Bundle",
});

/**
 * 生成 bundle 组唯一 id（与 bundle-configurator-custom.js 规则一致）
 * @returns {string}
 */
function generateyouweibundleid() {
  return "bundle_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
}

/**
 * 主商品行 properties：bundle-configurator 入车样式（_bundle_id + 各选项展示名对应数量 + 可选 _components）
 * @param {string} bundleId
 * @param {Record<string, string|number>} [quantitiesByLabel] - 键为 product title / sku / id 等展示键，值为数量
 * @param {Array<{id:number|string, quantity:number}>|null} [componentsList] - 写入 _components 的 JSON 数组；null/undefined 不写该键
 * @returns {Record<string, string>}
 */
function makeprops_bundle_main(bundleId, quantitiesByLabel = {}, componentsList = undefined) {
  if (bundleId == null || bundleId === "") {
    throw new Error("makeprops_bundle_main: bundleId is required");
  }
  const c = YOUWEI_CART_LINE_PROP;
  /** @type {Record<string, string>} */
  const props = { [c.BUNDLE_ID]: String(bundleId) };
  for (const [k, v] of Object.entries(quantitiesByLabel || {})) {
    if (k == null || k === "") continue;
    if (v == null || v === "") continue;
    props[String(k)] = String(v);
  }
  if (componentsList !== undefined) {
    const arr = Array.isArray(componentsList) ? componentsList : [];
    props[c.COMPONENTS] = arr.length ? JSON.stringify(arr) : "";
  }
  return props;
}

/**
 * 子配件行 properties：configurator / component-cart-items 通用（_is_component、可选 _bundle_id、_parent_key、_parent_bundle_id、Part of Bundle）
 * @param {string|number} partOfBundle - 展示用：主款 variant id 或主商品标题等（各入口用法不同）
 * @param {{ bundleId?: string, parentLineKey?: string, parentBundleId?: string }} [extras]
 * @returns {Record<string, string>}
 */
function makeprops_bundle_component(partOfBundle, extras = {}) {
  const c = YOUWEI_CART_LINE_PROP;
  const { bundleId, parentLineKey, parentBundleId } = extras || {};
  /** @type {Record<string, string>} */
  const props = {
    [c.IS_COMPONENT]: "true",
  };
  if (bundleId != null && bundleId !== "") props[c.BUNDLE_ID] = String(bundleId);
  if (parentLineKey != null && parentLineKey !== "") props[c.PARENT_KEY] = String(parentLineKey);
  if (parentBundleId != null && parentBundleId !== "") {
    props[c.PARENT_BUNDLE_ID] = String(parentBundleId);
  }
  if (partOfBundle != null && partOfBundle !== "") {
    props[c.PART_OF_BUNDLE] = String(partOfBundle);
  }
  return props;
}

/**
 * drawer 内 _syncComponents 期望的子行 properties（与 custom-cart-drawer 内联对象一致）
 * @param {string} parentLineKey - 主行 cart item key
 * @param {string} bundleProductTitle - 主商品 product_title
 * @returns {Record<string, string>}
 */
function makeprops_drawer_sync_component(parentLineKey, bundleProductTitle) {
  const c = YOUWEI_CART_LINE_PROP;
  return {
    [c.IS_COMPONENT]: "true",
    [c.PARENT_KEY]: String(parentLineKey),
    [c.PART_OF_BUNDLE]: String(bundleProductTitle),
  };
}

/**
 * drawer 保存 bundle 时在主行上合并的「统计类」属性（值一律转字符串，与现逻辑一致）
 * @param {{
 *   componentsJsonOrArray?: string|Array<{id:number|string, quantity:number}>,
 *   bundleTotalQty?: string|number,
 *   bundleFreeTotalQty?: string|number,
 *   bundleMaxQty?: string|number,
 *   bundleItemQty?: string|number,
 *   bundleLineSig?: string,
 *   groupTotalQty?: string|number,
 *   groupFreeTotalQty?: string|number,
 *   groupMaxQty?: string|number,
 * }} fields
 * @returns {Record<string, string>}
 */
function makeprops_drawer_bundle_totals(fields = {}) {
  const c = YOUWEI_CART_LINE_PROP;
  /** @type {Record<string, string>} */
  const out = {};
  const { componentsJsonOrArray } = fields;
  if (componentsJsonOrArray !== undefined) {
    out[c.COMPONENTS] =
      typeof componentsJsonOrArray === "string"
        ? componentsJsonOrArray
        : JSON.stringify(componentsJsonOrArray);
  }
  const numKeys = [
    [c.BUNDLE_TOTAL_QTY, fields.bundleTotalQty],
    [c.BUNDLE_FREE_TOTAL_QTY, fields.bundleFreeTotalQty],
    [c.BUNDLE_MAX_QTY, fields.bundleMaxQty],
    [c.BUNDLE_ITEM_QTY, fields.bundleItemQty],
    [c.GROUP_TOTAL_QTY, fields.groupTotalQty],
    [c.GROUP_FREE_TOTAL_QTY, fields.groupFreeTotalQty],
    [c.GROUP_MAX_QTY, fields.groupMaxQty],
  ];
  for (const [key, val] of numKeys) {
    if (val != null && val !== "") out[key] = String(val);
  }
  if (fields.bundleLineSig != null && fields.bundleLineSig !== "") {
    out[c.BUNDLE_LINE_SIG] = String(fields.bundleLineSig);
  }
  return out;
}

// --- 按 SKU 批量拉取商品（与 resolveProducts / bundle-products-data 同一套 Search + Section）---

/**
 * 从 Section 返回的 HTML 中解析 `application/json`（与 drawer 内 _fetchSectionData 行为一致）
 * @param {string} html
 * @returns {object|null}
 */
function youwei_parse_section_html_json(html) {
  if (!html || typeof html !== "string") return null;
  try {
    const scriptMatch = html.match(
      /<script\s+type="application\/json"[^>]*>([\s\S]*?)<\/script>/i,
    );
    if (scriptMatch && scriptMatch[1]) {
      return JSON.parse(scriptMatch[1].trim());
    }
    let jsonText = html.trim();
    if (jsonText.startsWith("<") && !jsonText.startsWith("<!--")) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      jsonText = doc.body.textContent.trim();
    }
    return JSON.parse(jsonText);
  } catch (e) {
    console.error("youwei_parse_section_html_json failed", e);
    return null;
  }
}

/**
 * @param {string} sku
 * @returns {string}
 */
function _youwei_sku_search_token(sku) {
  return `sku:"${String(sku).replace(/"/g, '\\"')}"`;
}

/**
 * 合并多批 search 返回的 product，按 product.id 去重并合并 variants
 * @param {object[][]} batches
 * @returns {object[]}
 */
function _youwei_merge_search_products(batches) {
  const byId = new Map();
  for (const list of batches) {
    if (!Array.isArray(list)) continue;
    for (const p of list) {
      if (!p || p.id == null) continue;
      if (!byId.has(p.id)) {
        byId.set(p.id, {
          ...p,
          variants: [...(p.variants || [])],
        });
      } else {
        const cur = byId.get(p.id);
        const seen = new Set((cur.variants || []).map((v) => v.id));
        for (const v of p.variants || []) {
          if (v && v.id != null && !seen.has(v.id)) {
            cur.variants.push(v);
            seen.add(v.id);
          }
        }
      }
    }
  }
  return [...byId.values()];
}

function _youwei_norm_sku(sku) {
  return String(sku || "").trim().toUpperCase();
}

async function _youwei_fetch_product_by_handle(handle, options = {}) {
  if (!handle) return null;
  const url = `${_cartUrl(`products/${handle}`)}?section_id=bundle-products-data`;
  const res = await fetch(url, { signal: options.signal });
  if (!res.ok) return null;
  const html = await res.text();
  const data = youwei_parse_section_html_json(html);
  return data?.product || null;
}

async function _youwei_resolve_product_by_sku_fallback(sku, options = {}) {
  let handle = "";
  const suggestUrl =
    `${_cartUrl("search/suggest.json")}?q=${encodeURIComponent(sku)}` +
    "&resources[type]=product&resources[options][fields]=title,vendor,product_type,variants.sku";
  try {
    const res = await fetch(suggestUrl, { signal: options.signal });
    if (res.ok) {
      const data = await res.json();
      const results = data?.resources?.results?.products || [];
      if (results.length > 0) handle = results[0].handle || "";
    }
  } catch {
    // ignore and continue fallback
  }
  if (!handle) {
    handle = String(sku)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }
  let product = await _youwei_fetch_product_by_handle(handle, options);
  if (!product && handle.startsWith("picpak-")) {
    product = await _youwei_fetch_product_by_handle(
      handle.replace(/^picpak-/, ""),
      options,
    );
  }
  return product;
}

/**
 * 按 SKU 列表批量查询商品（仅走 suggest + products/{handle}?section_id=...）
 * @param {string|string[]} skus - 一个或多个 SKU
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<{
 *   products: object[],
 *   bySku: Record<string, {
 *     product: object,
 *     variant: object,
 *     available: boolean,
 *     inventory_quantity: number,
 *     inventory_management: string|null,
 *     inventory_policy: string|null,
 *     tracked: boolean,
 *   }>,
 *   unmatched: string[],
 * }>}
 */
async function getproductsbysku(skus, options = {}) {
  const raw = Array.isArray(skus) ? skus : [skus];
  const list = [...new Set(raw.map((s) => String(s).trim()).filter(Boolean))];
  if (!list.length) {
    return { products: [], bySku: {}, unmatched: [] };
  }

  const bySku = {};
  const productsById = new Map();
  for (const sku of list) {
    const product = await _youwei_resolve_product_by_sku_fallback(sku, options);
    if (!product) continue;
    if (product.id != null && !productsById.has(product.id)) {
      productsById.set(product.id, product);
    }
    const targetSku = _youwei_norm_sku(sku);
    const variant = (product.variants || []).find(
      (v) => _youwei_norm_sku(v?.sku) === targetSku,
    ) || (product.variants || [])[0];
    if (variant) {
      bySku[sku] = {
        product,
        variant,
        available: !!variant.available,
        inventory_quantity: Number(variant.inventory_quantity ?? 0),
        inventory_management: variant.inventory_management ?? null,
        inventory_policy: variant.inventory_policy ?? null,
        tracked: !!variant.inventory_management,
      };
    }
  }

  return {
    products: [...productsById.values()],
    bySku,
    unmatched: list.filter((sku) => !bySku[sku]),
  };
}

function _extractBundleSkusFromCart(cart) {
  const skus = new Set();
  const items = cart?.items || [];
  for (const item of items) {
    const cfg = item?.bundle_config;
    if (!cfg) continue;
    const list = cfg?.products?.products || cfg?.products || cfg;
    if (!Array.isArray(list)) continue;
    for (const p of list) {
      const sku = String(p?.sku || "").trim();
      if (sku) skus.add(sku);
    }
  }
  return [...skus];
}

// const bootstrap = async () => {
//   const cart = await getcart();
//   const bundleSkus = _extractBundleSkusFromCart(cart);
//   if (!bundleSkus.length) {
//     console.log("No bundle SKUs found in cart.bundle_config");
//     return;
//   }
//   const skuResult = await getproductsbysku(bundleSkus)

//   console.log("skuResult", skuResult);
//   console.log('cart', cart);
// };
// bootstrap();
